<p-confirmDialog></p-confirmDialog>
<div class="page-layout">
  <!-- SIDEBAR FILTRES À GAUCHE -->
  <div class="filters-sidebar" *ngIf="!isPublicDevisRoute && activeStep === 3">
    <div class="filters-block">
      <div class="selected-products-panel" *ngIf="getSelectedCount() > 0">
        <div class="selected-products-header">
          <div class="selected-products-title">
            <i class="pi pi-shopping-cart"></i>
            Produits sélectionnés ({{ getSelectedCount() }})
          </div>
          <p-button type="button" label="Vider" icon="pi pi-trash"
            styleClass="p-button-text p-button-sm clear-selected-button" (onClick)="clearSelectedProducts()">
          </p-button>
        </div>
        <div class="selected-products-list">
          <div class="selected-product-item" *ngFor="let product of getSelectedProducts()">
            <div class="selected-product-logo" [ngSwitch]="product.type">
              <img *ngSwitchCase="'april'" src="assets/images/logos/april-logo.png" alt="April" />
              <img *ngSwitchCase="'utwin'" src="assets/images/logos/utwin-logo.png" alt="Utwin" />
              <img *ngSwitchCase="'cardif'" src="assets/images/logos/cardif-logo.png" alt="Cardif" />
              <img *ngSwitchCase="'afiesca'" src="assets/images/logos/afiesca-logo.png" alt="AFI-ESCA" />
              <img *ngSwitchCase="'neoliane'" src="assets/images/logos/neoliane-logo.png" alt="Neoliane" />
              <img *ngSwitchCase="'lifesquare'" src="assets/images/logos/logo-lifesquare.png" alt="LifeSquare" />
              <img *ngSwitchCase="'zenioo'" src="assets/images/logos/zenioo-logo.png" alt="Zenioo" />
              <div *ngSwitchDefault class="selected-product-logo-fallback">
                {{ product.type | uppercase }}
              </div>
            </div>
            <div class="selected-product-info">
              <div class="selected-product-name" [pTooltip]="product.productName">
                {{ product.productName }}
              </div>
              <div class="selected-product-price">
                {{ (product.monthlyPrice || product.price) | number:'1.2-2' }} €
                <span class="selected-product-price-period" *ngIf="product.monthlyPrice">/mois</span>
              </div>
            </div>
            <p-button type="button" icon="pi pi-times"
              styleClass="p-button-rounded p-button-text p-button-sm remove-selected-button"
              pTooltip="Retirer de la sélection" (onClick)="toggleProductSelection(product)">
            </p-button>
          </div>
        </div>

        <div class="selected-products-actions">
          <p-button type="button" label="Télécharger devis" icon="pi pi-download"
            styleClass="p-button-sm panier-btn-download" (onClick)="downloadSelectedQuotes()"
            [disabled]="getSelectedCount() === 0 || loading">
          </p-button>

          <p-button type="button"
            [label]="sendingSmsDevis ? 'Envoi…' : 'Envoyer devis et SMS'"
            icon="pi pi-envelope"
            styleClass="p-button-sm panier-btn-email"
            (onClick)="sendDevisAndSms()"
            [disabled]="getSelectedCount() === 0 || sendingSmsDevis || loading">
          </p-button>
        </div>
      </div>

      <div class="selected-products-actions" style="margin-bottom: 1rem;">
        <p-button type="button" label="Envoyer devis avec Economies" icon="pi pi-percentage"
          styleClass="p-button-sm panier-btn-amortissement" (onClick)="openAmortissementDialog()">
        </p-button>
      </div>

      <h4>Filtres de recherche</h4>

      <div class="filters-content">
        <!-- Type de cotisation -->
        <div class="filter-section cotisation-section">
          <h5>Type de cotisation</h5>
          <div class="filter-checkboxes">
            <div class="filter-item">
              <p-checkbox [(ngModel)]="filters.cotisationType.variable" binary="true" inputId="cotVar"></p-checkbox>
              <label for="cotVar">Cotisation variable</label>
            </div>
            <div class="filter-item">
              <p-checkbox [(ngModel)]="filters.cotisationType.constante" binary="true" inputId="cotConst"></p-checkbox>
              <label for="cotConst">Cotisation constante</label>
            </div>
          </div>
        </div>

        <!-- Mode d'indemnisation IPT -->
        <div class="filter-section">
          <h5>Mode d'indemnisation IPT</h5>
          <div class="filter-checkboxes">
            <div class="filter-item">
              <p-checkbox [(ngModel)]="filters.iptMode.rente" binary="true" inputId="iptRente"></p-checkbox>
              <label for="iptRente">En rente</label>
            </div>
            <div class="filter-item">
              <p-checkbox [(ngModel)]="filters.iptMode.capital" binary="true" inputId="iptCapital"></p-checkbox>
              <label for="iptCapital">En capital</label>
            </div>
          </div>
        </div>


        <!-- Coût total de l'assurance -->
        <div class="filter-section total-cost-section">
          <h5>Coût total de l'assurance</h5>
          <div class="cost-range">
            <div class="range-row">
              <label>Min:</label>
              <span class="cost-value red-badge">{{ filters.cost.min | number:'1.0-0' }}€</span>
              <input type="range" [min]="getMinMaxValues().totalCost.min" [max]="getMinMaxValues().totalCost.max"
                [(ngModel)]="filters.cost.min" (ngModelChange)="onFilterChange()" />
            </div>
            <div class="range-row">
              <label>Max:</label>
              <span class="cost-value red-badge">{{ filters.cost.max | number:'1.0-0' }}€</span>
              <input type="range" [min]="getMinMaxValues().totalCost.min" [max]="getMinMaxValues().totalCost.max"
                [(ngModel)]="filters.cost.max" (ngModelChange)="onFilterChange()" />
            </div>
          </div>
        </div>

        <!-- Coût sur 8 ans -->
        <div class="filter-section eight-years-cost-section">
          <h5>Coût sur 8 premières années</h5>
          <div class="cost-range">
            <div class="range-row">
              <label>Min:</label>
              <span class="cost-value red-badge">{{ filters.eightYearsCost.min | number:'1.0-0' }}€</span>
              <input type="range" [min]="getMinMaxValues().eightYearsCost.min"
                [max]="getMinMaxValues().eightYearsCost.max" [(ngModel)]="filters.eightYearsCost.min"
                (ngModelChange)="onFilterChange()" />
            </div>
            <div class="range-row">
              <label>Max:</label>
              <span class="cost-value red-badge">{{ filters.eightYearsCost.max | number:'1.0-0' }}€</span>
              <input type="range" [min]="getMinMaxValues().eightYearsCost.min"
                [max]="getMinMaxValues().eightYearsCost.max" [(ngModel)]="filters.eightYearsCost.max"
                (ngModelChange)="onFilterChange()" />
            </div>
          </div>
        </div>

        <!-- Compagnies -->
        <div class="filter-section companies-section">
          <h5>Compagnies d'assurance</h5>
          <div class="filter-checkboxes">
            <div class="filter-item">
              <p-checkbox [ngModel]="areAllCompaniesSelected()" (ngModelChange)="toggleAllCompanies($event)"
                binary="true" inputId="allCompanies">
              </p-checkbox>
              <label for="allCompanies">All</label>
            </div>
            <div class="filter-item">
              <p-checkbox [(ngModel)]="filters.companies.april" binary="true" inputId="april"></p-checkbox>
              <label for="april">April</label>
            </div>
            <div class="filter-item">
              <p-checkbox [(ngModel)]="filters.companies.utwin" binary="true" inputId="utwin"></p-checkbox>
              <label for="utwin">Utwin</label>
            </div>
            <div class="filter-item">
              <p-checkbox [(ngModel)]="filters.companies.cardif" binary="true" inputId="cardif"></p-checkbox>
              <label for="cardif">Cardif</label>
            </div>
            <div class="filter-item">
              <p-checkbox [(ngModel)]="filters.companies.afiesca" binary="true" inputId="afiesca"></p-checkbox>
              <label for="afiesca">AFI-ESCA</label>
            </div>
            <div class="filter-item">
              <p-checkbox [(ngModel)]="filters.companies.neoliane" binary="true" inputId="neoliane"></p-checkbox>
              <label for="neoliane">Neoliane</label>
            </div>
            <div class="filter-item">
              <p-checkbox [(ngModel)]="filters.companies.lifesquare" binary="true" inputId="lifesquare"></p-checkbox>
              <label for="lifesquare">LifeSquare</label>
            </div>
            <div class="filter-item">
              <p-checkbox [(ngModel)]="filters.companies.zenioo" binary="true" inputId="zenioo"></p-checkbox>
              <label for="zenioo">Zenioo</label>
            </div>
          </div>
        </div>

        <!-- Actions -->
      </div><!-- Fin .filters-content -->

    </div>
  </div>

  <!-- CONTENU PRINCIPAL -->
  <div class="comparaison-container" [class.loading-blur]="loading && canCancel">
    <p-steps [model]="steps" [activeIndex]="activeStep" (activeIndexChange)="goToStep($event)" [readonly]="false"
      class="mb-4"></p-steps>
    <p-toast></p-toast>

    <form [formGroup]="comparaisonForm" (ngSubmit)="onSubmit()" class="comparaison-form">

      <!-- Étape 1 : Emprunteur -->
      <div *ngIf="activeStep === 0" class="form-step">
        <fieldset>
          <div class="lead-status-block" *ngIf="!isPublicDevisRoute">
            <span class="lead-status-title">Statut du lead :</span>
            <span class="lead-status-value" [ngClass]="leadStatusCssClass">{{ leadStatusLabel }}</span>
          </div>
          <legend>📋 Informations du Projet</legend>
          <div class="form-row">
            <div class="form-group">
              <label for="typeProjet" class="field-label-enhanced">
                <i class="pi pi-home"></i>
                Nature du Projet Immobilier
              </label>
              <p-dropdown formControlName="typeProjet" [options]="typesProjets"
                placeholder="Achat, construction, travaux..." id="typeProjet" optionLabel="label" optionValue="value">
              </p-dropdown>
              <div *ngIf="comparaisonForm.get('typeProjet')?.invalid && comparaisonForm.get('typeProjet')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> Veuillez sélectionner le type de projet
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group"
              [ngClass]="{ 'has-error': comparaisonForm.get('deplacementProfessionnel')?.invalid && comparaisonForm.get('deplacementProfessionnel')?.touched }">
              <label for="typeReprise" class="field-label-enhanced">
                <i class="pi pi-sync"></i>
                Type de Reprise d'Assurance
              </label>
              <p-dropdown formControlName="typeReprise" [options]="availableTypeRepriseOptions"
                placeholder="Nouvelle assurance ou reprise ?" id="typeReprise" optionLabel="label"
                optionValue="value"></p-dropdown>
              <div *ngIf="comparaisonForm.get('typeReprise')?.invalid && comparaisonForm.get('typeReprise')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> Ce champ est obligatoire
              </div>
            </div>
            <div class="form-group"
              [ngClass]="{ 'has-error': comparaisonForm.get('travailleEnHauteur')?.invalid && comparaisonForm.get('travailleEnHauteur')?.touched }">
              <label for="dateEffective" class="field-label-enhanced">
                <i class="pi pi-calendar"></i>
                Date d'Effet Souhaitée
              </label>
              <input pInputText formControlName="dateEffective" id="dateEffective" placeholder="Ex: 15122025"
                appDateFormat maxlength="10" />
              <div
                *ngIf="comparaisonForm.get('dateEffective')?.invalid && comparaisonForm.get('dateEffective')?.touched"
                class="error-message">
                <div *ngIf="comparaisonForm.get('dateEffective')?.errors?.['required']"><i
                    class="pi pi-exclamation-circle"></i> Ce champ est obligatoire</div>
                <div *ngIf="comparaisonForm.get('dateEffective')?.errors?.['invalidDateFormat']"><i
                    class="pi pi-exclamation-circle"></i> Format invalide. Utilisez JJMMAAAA</div>
                <div *ngIf="comparaisonForm.get('dateEffective')?.errors?.['invalidMonth']"><i
                    class="pi pi-exclamation-circle"></i> Mois invalide (01-12)</div>
                <div *ngIf="comparaisonForm.get('dateEffective')?.errors?.['invalidDay']"><i
                    class="pi pi-exclamation-circle"></i> Jour invalide (01-31)</div>
                <div *ngIf="comparaisonForm.get('dateEffective')?.errors?.['invalidDayForMonth']"><i
                    class="pi pi-exclamation-circle"></i> Jour invalide pour ce mois</div>
                <div *ngIf="comparaisonForm.get('dateEffective')?.errors?.['invalidYear']"><i
                    class="pi pi-exclamation-circle"></i> Année invalide (1900-2100)</div>
                <div *ngIf="comparaisonForm.get('dateEffective')?.errors?.['pastDate']"><i
                    class="pi pi-exclamation-circle"></i> La date doit être dans le futur</div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="banque" class="field-label-enhanced">
                <i class="pi pi-building"></i>
                Établissement Bancaire
              </label>
              <p-dropdown formControlName="banque" [options]="banques" placeholder="Quelle est votre banque ?"
                id="banque" [filter]="true" filterPlaceholder="Rechercher votre banque..." [showClear]="true"
                optionLabel="label" optionValue="value" styleClass="w-full">
              </p-dropdown>
              <div *ngIf="comparaisonForm.get('banque')?.invalid && comparaisonForm.get('banque')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> Veuillez sélectionner votre banque
              </div>
              <div *ngIf="loadedProjectFieldComments.banque" class="field-comment-note">
                {{ loadedProjectFieldComments.banque }}
              </div>

              <!-- ═══ Aide recherche régionale par code postal ═══ -->
              <div class="banque-helper-container">
                <button type="button" class="banque-helper-toggle"
                  (click)="banqueHelperShowPanel = !banqueHelperShowPanel; onBanqueHelperFocus()">
                  <i class="pi pi-search"></i>
                  Trouver la caisse régionale par code postal
                  <i class="pi" [ngClass]="banqueHelperShowPanel ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                </button>

                <div class="banque-helper-panel" *ngIf="banqueHelperShowPanel">
                  <div class="banque-helper-fields">
                    <div class="banque-helper-field">
                      <label class="banque-helper-label">Famille bancaire</label>
                      <select class="banque-helper-select" [(ngModel)]="banqueHelperFamily"
                        [ngModelOptions]="{standalone: true}" (ngModelChange)="onBanqueHelperChange()">
                        <option value="">— Choisir —</option>
                        <option *ngFor="let f of bankFamilies" [value]="f.familyName">{{ f.familyName }}</option>
                      </select>
                    </div>
                    <div class="banque-helper-field">
                      <label class="banque-helper-label">Code postal</label>
                      <input type="text" class="banque-helper-input" [(ngModel)]="banqueHelperPostal"
                        [ngModelOptions]="{standalone: true}" placeholder="Ex : 14000" maxlength="5"
                        (ngModelChange)="onBanqueHelperChange()" />
                    </div>
                  </div>

                  <div class="banque-helper-results" *ngIf="banqueHelperResults.length > 0">
                    <div class="banque-helper-hint">Cliquez pour sélectionner :</div>
                    <div class="banque-helper-chip" *ngFor="let r of banqueHelperResults"
                      (click)="selectBanqueFromHelper(r.value)">
                      <i class="pi pi-check-circle"></i> {{ r.label }}
                    </div>
                  </div>
                  <div class="banque-helper-empty"
                    *ngIf="banqueHelperFamily && banqueHelperPostalIsValid && banqueHelperResults.length === 0">
                    <i class="pi pi-info-circle"></i> Aucune correspondance trouvée pour ce code postal.
                  </div>
                </div>
              </div>
              <!-- ═══ Fin aide recherche régionale ═══ -->
            </div>
            <div class="form-group" *ngIf="!isPublicDevisRoute">
              <label for="origine" class="field-label-enhanced">
                <i class="pi pi-map-marker"></i>
                Origine du Contact
              </label>
              <p-dropdown formControlName="origine" [options]="origines" placeholder="Comment nous avez-vous trouvé ?"
                id="origine" optionLabel="label" optionValue="value">
              </p-dropdown>
              <div *ngIf="comparaisonForm.get('origine')?.invalid && comparaisonForm.get('origine')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> Veuillez indiquer comment vous nous avez trouvé
              </div>
            </div>
          </div>
          <div class="form-row" *ngIf="comparaisonForm.get('typeProjet')?.value === 'investissement_locatif'">
            <div class="form-group">
              <label for="nomProjet" class="field-label-enhanced">
                <i class="pi pi-tag"></i>
                Nom du projet immobilier
              </label>
              <input pInputText formControlName="nomProjet" id="nomProjet" placeholder="Nom du projet (facultatif)" />
            </div>
          </div>
        </fieldset>
        <fieldset>
          <legend>👤 Informations de l'Emprunteur</legend>
          <div class="form-row">
            <div class="form-group">
              <label for="typeSouscripteur" class="field-label-enhanced">
                <i class="pi pi-user"></i>
                Statut du Souscripteur
              </label>
              <p-dropdown formControlName="typeSouscripteur" [options]="typeSouscripteurs"
                placeholder="Particulier ou Professionnel ?" id="typeSouscripteur"></p-dropdown>
              <div
                *ngIf="comparaisonForm.get('typeSouscripteur')?.invalid && comparaisonForm.get('typeSouscripteur')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> Ce champ est obligatoire
              </div>
            </div>
          </div>
          <div *ngIf="comparaisonForm.get('typeSouscripteur')?.value === 'Personne morale'" class="form-row">
            <div class="form-group">
              <label for="raisonSociale" class="field-label-enhanced">
                <i class="pi pi-briefcase"></i>
                Raison Sociale de l'Entreprise *
              </label>
              <input pInputText formControlName="raisonSociale" id="raisonSociale" placeholder="Nom de votre société" />
              <div
                *ngIf="comparaisonForm.get('raisonSociale')?.invalid && comparaisonForm.get('raisonSociale')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> La raison sociale est obligatoire
              </div>
            </div>
            <div class="form-group">
              <label for="formeJuridique" class="field-label-enhanced">
                <i class="pi pi-building"></i>
                Forme Juridique de la Société *
              </label>
              <p-dropdown formControlName="formeJuridique" [options]="formesJuridiques"
                placeholder="SARL, SAS, SA, EURL..." id="formeJuridique" [showClear]="true">
              </p-dropdown>
              <div
                *ngIf="comparaisonForm.get('formeJuridique')?.invalid && comparaisonForm.get('formeJuridique')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> La forme juridique est obligatoire
              </div>
            </div>
          </div>
          <div class="form-row">

            <div class="form-group">
              <label for="civilite" class="field-label-enhanced">
                <i class="pi pi-id-card"></i>
                Civilité *
              </label>
              <p-dropdown formControlName="civilite" [options]="civilites" placeholder="Sélectionner une civilité"
                id="civilite"></p-dropdown>
              <div *ngIf="comparaisonForm.get('civilite')?.invalid && comparaisonForm.get('civilite')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> La civilité est obligatoire
              </div>
            </div>
            <div class="form-group">
              <label for="nom" class="field-label-enhanced">
                <i class="pi pi-user"></i>
                Nom de famille *
              </label>
              <input pInputText formControlName="nom" id="nom" placeholder="Saisir le nom..."
                (blur)="onBorrowerNomBlur()" />
              <div *ngIf="comparaisonForm.get('nom')?.invalid && comparaisonForm.get('nom')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> Le nom est obligatoire
              </div>
            </div>
            <div class="form-group">
              <label for="prenom" class="field-label-enhanced">
                <i class="pi pi-user"></i>
                Prénom *
              </label>
              <input pInputText formControlName="prenom" id="prenom" placeholder="Saisir le prénom..."
                (blur)="onBorrowerPrenomBlur()" />
              <div *ngIf="comparaisonForm.get('prenom')?.invalid && comparaisonForm.get('prenom')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> Le prénom est obligatoire
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="email" class="field-label-enhanced">
                <i class="pi pi-envelope"></i>
                Email *
              </label>
              <input pInputText formControlName="email" id="email" type="email" placeholder="votre@email.com"
                (blur)="onEmailBlurForContactLookup()" />
              <div *ngIf="comparaisonForm.get('email')?.invalid && comparaisonForm.get('email')?.touched"
                class="error-message">
                <div *ngIf="comparaisonForm.get('email')?.errors?.['required']">
                  <i class="pi pi-exclamation-circle"></i> Email obligatoire
                </div>
                <div *ngIf="comparaisonForm.get('email')?.errors?.['email']">
                  <i class="pi pi-exclamation-circle"></i> Format email invalide
                </div>
                <div *ngIf="comparaisonForm.get('email')?.errors?.['abstractEmail']">
                  <i class="pi pi-exclamation-circle"></i> {{ comparaisonForm.get('email')?.errors?.['abstractEmail'] }}
                </div>
              </div>
              <div *ngIf="comparaisonForm.get('email')?.errors?.['contactMustChange']" class="error-message">
                <i class="pi pi-exclamation-circle"></i> {{ comparaisonForm.get('email')?.errors?.['contactMustChange'] }}
              </div>
              <div *ngIf="contactLookupChecking" class="field-validation-note pending">
                Recherche d'un contact existant...
              </div>
              <div *ngIf="emailValidationState.message" class="field-validation-note"
                [ngClass]="{ 'success': emailValidationState.valid === true, 'error': emailValidationState.valid === false, 'pending': emailValidationState.checking }">
                {{ emailValidationState.message }}
              </div>
            </div>
            <div class="form-group">
              <label for="dateNaissance" class="field-label-enhanced">
                <i class="pi pi-calendar"></i>
                Date de naissance *
              </label>
              <input pInputText formControlName="dateNaissance" id="dateNaissance" placeholder="jjmmaaaa" appDateFormat
                maxlength="10" />
              <div class="age-label" *ngIf="ageEmprunteur !== null">
                <i class="pi pi-user"></i> Âge : <strong>{{ ageEmprunteur }} ans</strong>
              </div>
              <div
                *ngIf="comparaisonForm.get('dateNaissance')?.invalid && comparaisonForm.get('dateNaissance')?.touched"
                class="error-message">
                <div *ngIf="comparaisonForm.get('dateNaissance')?.errors?.['required']"><i
                    class="pi pi-exclamation-circle"></i> La date de naissance est obligatoire</div>
                <div *ngIf="comparaisonForm.get('dateNaissance')?.errors?.['invalidDateFormat']"><i
                    class="pi pi-exclamation-circle"></i> Format invalide. Utilisez JJMMAAAA</div>
                <div *ngIf="comparaisonForm.get('dateNaissance')?.errors?.['invalidMonth']"><i
                    class="pi pi-exclamation-circle"></i> Mois invalide (01-12)</div>
                <div *ngIf="comparaisonForm.get('dateNaissance')?.errors?.['invalidDay']"><i
                    class="pi pi-exclamation-circle"></i> Jour invalide (01-31)</div>
                <div *ngIf="comparaisonForm.get('dateNaissance')?.errors?.['invalidDayForMonth']"><i
                    class="pi pi-exclamation-circle"></i> Jour invalide pour ce mois</div>
                <div *ngIf="comparaisonForm.get('dateNaissance')?.errors?.['invalidYear']"><i
                    class="pi pi-exclamation-circle"></i> Année invalide (1900-2100)</div>
                <div *ngIf="comparaisonForm.get('dateNaissance')?.errors?.['futureDate']"><i
                    class="pi pi-exclamation-circle"></i> La date de naissance ne peut pas être dans le futur</div>
              </div>
            </div>

          </div>

          <div class="form-group">
            <label for="professionalCategory" class="field-label-enhanced">
              <i class="pi pi-briefcase"></i>
              Catégorie professionnelle *
            </label>
            <p-dropdown id="professionalCategory" formControlName="professionalCategory"
              [options]="professionalCategories" optionLabel="label" optionValue="value"
              placeholder="Sélectionnez une catégorie" [showClear]="true" [filter]="true"
              filterPlaceholder="Rechercher une catégorie..." styleClass="w-full">
            </p-dropdown>
            <div
              *ngIf="comparaisonForm.get('professionalCategory')?.invalid && comparaisonForm.get('professionalCategory')?.touched"
              class="error-message">
              <i class="pi pi-exclamation-circle"></i> La catégorie professionnelle est obligatoire
            </div>
            <div *ngIf="loadedProjectFieldComments.professionalCategory" class="field-comment-note">
              {{ loadedProjectFieldComments.professionalCategory }}
            </div>
            <div class="form-group">
              <label for="profession" class="field-label-enhanced">
                <i class="pi pi-id-card"></i>
                Profession *
              </label>
              <p-dropdown *ngIf="!isPublicDevisRoute" formControlName="profession" [options]="profession"
                [showClear]="true" [filter]="true" filterPlaceholder="Rechercher une profession"
                placeholder="Sélectionner une profession" id="profession"></p-dropdown>
              <input *ngIf="isPublicDevisRoute" pInputText formControlName="profession" id="profession"
                placeholder="Saisir votre profession..." />
              <div *ngIf="comparaisonForm.get('profession')?.invalid && comparaisonForm.get('profession')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> La profession est obligatoire
              </div>
              <div *ngIf="loadedProjectFieldComments.profession" class="field-comment-note">
                {{ loadedProjectFieldComments.profession }}
              </div>
            </div>
          </div>
        </fieldset>

        <fieldset>
          <legend>Adresse</legend>
          <div class="form-row">
            <div class="form-group">
              <label for="adresse" class="field-label-enhanced">
                <i class="pi pi-map-marker"></i>
                Adresse *
              </label>
              <p-autoComplete formControlName="adresse" id="adresse" [suggestions]="suggestionsAddresses"
                (completeMethod)="searchAddress($event)" (onSelect)="onAddressSelect($event)" field="properties.label"
                placeholder="Numéro et nom de rue..." [minLength]="3" styleClass="w-full"
                [inputStyle]="{'width':'100%'}">
                <ng-template let-suggestion pTemplate="item">
                  <div style="font-size: 0.9em; padding: 0.25rem 0;">{{ suggestion.properties.label }}</div>
                </ng-template>
              </p-autoComplete>
              <div *ngIf="comparaisonForm.get('adresse')?.invalid && comparaisonForm.get('adresse')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> L'adresse est obligatoire
              </div>
            </div>
            <div class="form-group">
              <label for="complementAdresse" class="field-label-enhanced">
                <i class="pi pi-home"></i>
                Complément d'adresse
              </label>
              <input pInputText formControlName="complementAdresse" id="complementAdresse"
                placeholder="Appartement, bâtiment..." />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="codePostal" class="field-label-enhanced">
                <i class="pi pi-inbox"></i>
                Code postal *
              </label>
              <input pInputText formControlName="codePostal" id="codePostal" placeholder="Code postal" />
              <div *ngIf="comparaisonForm.get('codePostal')?.invalid && comparaisonForm.get('codePostal')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> Code postal obligatoire (4-5 chiffres)
              </div>
            </div>
            <div class="form-group">
              <label for="ville" class="field-label-enhanced">
                <i class="pi pi-map"></i>
                Ville *
              </label>
              <ng-container *ngIf="cityOptions.length > 1; else villeInputText">
                <p-dropdown formControlName="ville" [options]="cityOptions" placeholder="Choisir une ville" id="ville"
                  optionLabel="label" optionValue="value" [filter]="true" filterBy="label" [showClear]="true">
                </p-dropdown>
              </ng-container>
              <ng-template #villeInputText>
                <input pInputText formControlName="ville" id="ville" placeholder="Ville" />
              </ng-template>
              <div *ngIf="comparaisonForm.get('ville')?.invalid && comparaisonForm.get('ville')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> La ville est obligatoire
              </div>
              <div *ngIf="loadedProjectFieldComments.ville" class="field-comment-note">
                {{ loadedProjectFieldComments.ville }}
              </div>
            </div>
            <div class="form-group">
              <label for="pays" class="field-label-enhanced">
                <i class="pi pi-globe"></i>
                Pays *
              </label>
              <p-dropdown formControlName="pays" [options]="pays" placeholder="Sélectionner un pays" id="pays"
                optionLabel="name" optionValue="code" [filter]="true" filterBy="name,code" [showClear]="true">
                <ng-template pTemplate="selectedItem">
                  <div *ngIf="comparaisonForm.get('pays')?.value as selectedCode">
                    <span class="fi fi-{{ selectedCode.toLowerCase() }}"></span>
                    {{ getCountryName(selectedCode) }}
                  </div>
                </ng-template>
                <ng-template let-country pTemplate="item">
                  <div class="flex align-items-center">
                    <span class="fi fi-{{ country.code.toLowerCase() }}" style="margin-right: 0.5rem;"></span>
                    <span>{{ country.name }} ({{ country.code }})</span>
                  </div>
                </ng-template>
              </p-dropdown>
              <div *ngIf="comparaisonForm.get('pays')?.invalid && comparaisonForm.get('pays')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> Le pays est obligatoire
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="telephone" class="field-label-enhanced">
                <i class="pi pi-phone"></i>
                Téléphone
              </label>
              <input pInputText type="tel" formControlName="telephone" id="telephone" placeholder="Numéro de téléphone"
                (blur)="onTelephoneBlurForContactLookup()" (paste)="onTelephonePaste()" />
              <div *ngIf="comparaisonForm.get('telephone')?.invalid && comparaisonForm.get('telephone')?.touched"
                class="error-message">
                <div *ngIf="comparaisonForm.get('telephone')?.errors?.['contactMustChange']">
                  <i class="pi pi-exclamation-circle"></i> {{ comparaisonForm.get('telephone')?.errors?.['contactMustChange'] }}
                </div>
                <div *ngIf="!comparaisonForm.get('telephone')?.errors?.['contactMustChange']">
                  <i class="pi pi-exclamation-circle"></i> Format de téléphone invalide
                </div>
              </div>
              <button *ngIf="comparaisonForm.get('telephone')?.value" pButton type="button"
                icon="pi pi-phone" label="Appeler"
                class="p-button-sm p-button-outlined"
                style="color:#16a34a;border-color:#16a34a;margin-top:6px"
                (click)="callPhone(comparaisonForm.get('telephone')?.value)">
              </button>
            </div>
          </div>
        </fieldset>

        <fieldset>
          <legend>Situation Professionnelle</legend>

          <!-- Première ligne : Déplacement professionnel et Travail en hauteur -->
          <div class="form-row">
            <div class="form-group"
              [ngClass]="{ 'has-error': comparaisonForm.get('deplacementProfessionnel')?.invalid && comparaisonForm.get('deplacementProfessionnel')?.touched }">
              <label for="deplacementProfessionnel" class="field-label-enhanced">
                <i class="pi pi-car"></i>
                Déplacement professionnel *
              </label>
              <div class="radio-group" role="radiogroup" aria-labelledby="deplacementProfessionnel-label">
                <div class="radio-option" *ngFor="let option of deplacementOptions; trackBy: trackByValue">
                  <p-radioButton [inputId]="'deplacement-' + option.value" [value]="option.value"
                    formControlName="deplacementProfessionnel" name="deplacementProfessionnel"></p-radioButton>
                  <label [for]="'deplacement-' + option.value" class="radio-label"
                    style="margin-left: 0.5rem; cursor: pointer;">
                    {{ option.label }}
                  </label>
                </div>
              </div>
              <div
                *ngIf="comparaisonForm.get('deplacementProfessionnel')?.invalid && comparaisonForm.get('deplacementProfessionnel')?.touched"
                class="error-message" role="alert">
                <i class="pi pi-exclamation-circle"></i> Le déplacement professionnel est obligatoire
              </div>
            </div>

            <div class="form-group"
              [ngClass]="{ 'has-error': comparaisonForm.get('travailleEnHauteur')?.invalid && comparaisonForm.get('travailleEnHauteur')?.touched }">
              <label for="travailleEnHauteur" class="field-label-enhanced">
                <i class="pi pi-arrow-up"></i>
                Travail en hauteur *
              </label>
              <div class="radio-group" role="radiogroup" aria-labelledby="travailleEnHauteur-label">
                <div class="radio-option" *ngFor="let option of travailEnHauteurOptions; trackBy: trackByValue">
                  <p-radioButton [inputId]="'hauteur-' + option.value" [value]="option.value"
                    formControlName="travailleEnHauteur" name="travailleEnHauteur"></p-radioButton>
                  <label [for]="'hauteur-' + option.value" class="radio-label"
                    style="margin-left: 0.5rem; cursor: pointer;">
                    {{ option.label }}
                  </label>
                </div>
              </div>
              <div
                *ngIf="comparaisonForm.get('travailleEnHauteur')?.invalid && comparaisonForm.get('travailleEnHauteur')?.touched"
                class="error-message" role="alert">
                <i class="pi pi-exclamation-circle"></i> Le travail en hauteur est obligatoire
              </div>
            </div>
          </div>

          <!-- Deuxième ligne : Checkboxes et encours -->
          <div class="form-row">
            <div class="form-group checkbox-group">
              <p-checkbox formControlName="portCharge" binary="true" inputId="portCharge"></p-checkbox>
              <label for="portCharge" class="field-label-enhanced" style="margin-bottom: 0;">
                <i class="pi pi-box"></i>
                Port de charge
              </label>
            </div>

            <div class="form-group checkbox-group">
              <p-checkbox formControlName="fumeur" binary="true" inputId="fumeur"></p-checkbox>
              <label for="fumeur" class="field-label-enhanced" style="margin-bottom: 0;">
                <i class="pi pi-ban"></i>
                Fumeur
              </label>
            </div>

            <div class="form-group">
              <label for="enCoursTotalAssure" class="field-label-enhanced">
                <i class="pi pi-wallet"></i>
                Encours total assuré
              </label>
              <input pInputText formControlName="enCoursTotalAssure" id="enCoursTotalAssure" placeholder="200000"
                type="number" />
              <div
                *ngIf="comparaisonForm.get('enCoursTotalAssure')?.invalid && comparaisonForm.get('enCoursTotalAssure')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> L'encours total doit être positif
              </div>
            </div>
          </div>
        </fieldset>

        <!-- Bouton pour ajouter co-emprunteur -->
        <div class="form-actions-inline" *ngIf="!showCoEmprunteur">
          <p-button type="button" label="Ajouter un co-emprunteur" icon="pi pi-user-plus"
            (onClick)="ajouterCoEmprunteur()" styleClass="p-button-outlined"></p-button>
        </div>

        <!-- Section Co-emprunteur -->
        <fieldset *ngIf="showCoEmprunteur" class="co-emprunteur-section">
          <legend>
            Informations Co-emprunteur
            <p-button type="button" icon="pi pi-times" (onClick)="supprimerCoEmprunteur()"
              styleClass="p-button-text p-button-sm delete-button" pTooltip="Supprimer le co-emprunteur"></p-button>
          </legend>
          <div class="form-row">
            <div class="form-group">
              <label for="coEmprunteurCivilite" class="field-label-enhanced">
                <i class="pi pi-id-card"></i>
                Civilité *
              </label>
              <p-dropdown formControlName="coEmprunteurCivilite" [options]="civilites"
                placeholder="Sélectionner une civilité" id="coEmprunteurCivilite"></p-dropdown>
              <div
                *ngIf="comparaisonForm.get('coEmprunteurCivilite')?.invalid && comparaisonForm.get('coEmprunteurCivilite')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> La civilité est obligatoire
              </div>
            </div>
            <div class="form-group">
              <label for="coEmprunteurNom" class="field-label-enhanced">
                <i class="pi pi-user"></i>
                Nom de famille *
              </label>
              <input pInputText formControlName="coEmprunteurNom" id="coEmprunteurNom"
                placeholder="Identique au nom emprunteur" (blur)="onCoBorrowerNomBlur()" />
              <div
                *ngIf="comparaisonForm.get('coEmprunteurNom')?.invalid && comparaisonForm.get('coEmprunteurNom')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> Le nom est obligatoire
              </div>
            </div>
            <div class="form-group">
              <label for="coEmprunteurPrenom" class="field-label-enhanced">
                <i class="pi pi-user"></i>
                Prénom *
              </label>
              <input pInputText formControlName="coEmprunteurPrenom" id="coEmprunteurPrenom" placeholder="Prénom"
                (blur)="onCoBorrowerPrenomBlur()" />
              <div
                *ngIf="comparaisonForm.get('coEmprunteurPrenom')?.invalid && comparaisonForm.get('coEmprunteurPrenom')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> Le prénom est obligatoire
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="coEmprunteurEmail" class="field-label-enhanced">
                <i class="pi pi-envelope"></i>
                Email
              </label>
              <input pInputText formControlName="coEmprunteurEmail" id="coEmprunteurEmail" type="email"
                placeholder="email@exemple.com" />
              <div
                *ngIf="comparaisonForm.get('coEmprunteurEmail')?.invalid && comparaisonForm.get('coEmprunteurEmail')?.touched"
                class="error-message">
                <div *ngIf="comparaisonForm.get('coEmprunteurEmail')?.errors?.['email']">
                  <i class="pi pi-exclamation-circle"></i> Format email invalide
                </div>
                <div *ngIf="comparaisonForm.get('coEmprunteurEmail')?.errors?.['abstractEmail']">
                  <i class="pi pi-exclamation-circle"></i> {{
                  comparaisonForm.get('coEmprunteurEmail')?.errors?.['abstractEmail'] }}
                </div>
                <div *ngIf="comparaisonForm.get('coEmprunteurEmail')?.errors?.['sameAsBorrower']">
                  <i class="pi pi-exclamation-circle"></i> L'email du co-emprunteur doit être différent de celui de
                  l'emprunteur
                </div>
              </div>
              <div *ngIf="coEmailValidationState.message" class="field-validation-note"
                [ngClass]="{ 'success': coEmailValidationState.valid === true, 'error': coEmailValidationState.valid === false, 'pending': coEmailValidationState.checking }">
                {{ coEmailValidationState.message }}
              </div>
            </div>
            <div class="form-group">
              <label for="coEmprunteurDateNaissance" class="field-label-enhanced">
                <i class="pi pi-calendar"></i>
                Date de naissance *
              </label>
              <input pInputText formControlName="coEmprunteurDateNaissance" id="coEmprunteurDateNaissance"
                placeholder="jjmmaaaa" appDateFormat maxlength="10" />
              <div class="age-label" *ngIf="ageCoEmprunteur !== null">
                <i class="pi pi-user"></i> Âge : <strong>{{ ageCoEmprunteur }} ans</strong>
              </div>
              <div
                *ngIf="comparaisonForm.get('coEmprunteurDateNaissance')?.invalid && comparaisonForm.get('coEmprunteurDateNaissance')?.touched"
                class="error-message">
                <div *ngIf="comparaisonForm.get('coEmprunteurDateNaissance')?.errors?.['required']"><i
                    class="pi pi-exclamation-circle"></i> La date de naissance est obligatoire</div>
                <div *ngIf="comparaisonForm.get('coEmprunteurDateNaissance')?.errors?.['invalidDateFormat']"><i
                    class="pi pi-exclamation-circle"></i> Format
                  invalide. Utilisez JJMMAAAA</div>
                <div *ngIf="comparaisonForm.get('coEmprunteurDateNaissance')?.errors?.['invalidMonth']"><i
                    class="pi pi-exclamation-circle"></i> Mois invalide
                  (01-12)</div>
                <div *ngIf="comparaisonForm.get('coEmprunteurDateNaissance')?.errors?.['invalidDay']"><i
                    class="pi pi-exclamation-circle"></i> Jour invalide
                  (01-31)</div>
                <div *ngIf="comparaisonForm.get('coEmprunteurDateNaissance')?.errors?.['invalidDayForMonth']"><i
                    class="pi pi-exclamation-circle"></i> Jour
                  invalide pour ce mois</div>
                <div *ngIf="comparaisonForm.get('coEmprunteurDateNaissance')?.errors?.['invalidYear']"><i
                    class="pi pi-exclamation-circle"></i> Année invalide
                  (1900-2100)</div>
                <div *ngIf="comparaisonForm.get('coEmprunteurDateNaissance')?.errors?.['futureDate']"><i
                    class="pi pi-exclamation-circle"></i> La date de
                  naissance ne peut pas être dans le futur</div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="coEmprunteurProfessionalCategory" class="field-label-enhanced">
              <i class="pi pi-briefcase"></i>
              Catégorie professionnelle *
            </label>
            <p-dropdown id="coEmprunteurProfessionalCategory" formControlName="coEmprunteurProfessionalCategory"
              [options]="professionalCategories" optionLabel="label" optionValue="value"
              placeholder="Sélectionnez une catégorie" [showClear]="true" [filter]="true" filterBy="label,value"
              filterPlaceholder="Rechercher une catégorie" styleClass="w-full">
            </p-dropdown>
            <div
              *ngIf="comparaisonForm.get('coEmprunteurProfessionalCategory')?.invalid && comparaisonForm.get('coEmprunteurProfessionalCategory')?.touched"
              class="error-message">
              <i class="pi pi-exclamation-circle"></i> La catégorie professionnelle est obligatoire
            </div>
            <div *ngIf="loadedProjectFieldComments.coEmprunteurProfessionalCategory" class="field-comment-note">
              {{ loadedProjectFieldComments.coEmprunteurProfessionalCategory }}
            </div>
          </div>
          <div class="form-group">
            <label for="coEmprunteurProfession" class="field-label-enhanced">
              <i class="pi pi-id-card"></i>
              Profession *
            </label>
            <p-dropdown *ngIf="!isPublicDevisRoute" formControlName="coEmprunteurProfession" [options]="profession"
              [showClear]="true" [filter]="true" filterPlaceholder="Rechercher une profession"
              placeholder="Sélectionner une profession" id="coEmprunteurProfession"></p-dropdown>
            <input *ngIf="isPublicDevisRoute" pInputText formControlName="coEmprunteurProfession"
              id="coEmprunteurProfession" placeholder="Saisir la profession..." />
            <div
              *ngIf="comparaisonForm.get('coEmprunteurProfession')?.invalid && comparaisonForm.get('coEmprunteurProfession')?.touched"
              class="error-message">
              <i class="pi pi-exclamation-circle"></i> La profession est obligatoire
            </div>
            <div *ngIf="loadedProjectFieldComments.coEmprunteurProfession" class="field-comment-note">
              {{ loadedProjectFieldComments.coEmprunteurProfession }}
            </div>
          </div>
          <fieldset class="nested-fieldset">
            <legend>Situation Professionnelle Co-emprunteur</legend>

            <!-- Première ligne : Déplacement professionnel et Travail en hauteur -->
            <div class="form-row">
              <div class="form-group"
                [ngClass]="{ 'has-error': comparaisonForm.get('coEmprunteurDeplacementProfessionnel')?.invalid && comparaisonForm.get('coEmprunteurDeplacementProfessionnel')?.touched }">
                <label for="coEmprunteurDeplacementProfessionnel" class="form-label">Déplacement professionnel
                  co-emprunteur *</label>
                <div class="radio-group" role="radiogroup" aria-labelledby="coEmprunteurDeplacementProfessionnel-label">
                  <div class="radio-option"
                    *ngFor="let option of coEmprunteurDeplacementOptions; trackBy: trackByValue">
                    <p-radioButton [inputId]="'co-deplacement-' + option.value" [value]="option.value"
                      formControlName="coEmprunteurDeplacementProfessionnel"
                      name="coEmprunteurDeplacementProfessionnel"></p-radioButton>
                    <label [for]="'co-deplacement-' + option.value" class="radio-label"
                      style="margin-left: 0.5rem; cursor: pointer;">
                      {{ option.label }}
                    </label>
                  </div>
                </div>
                <div
                  *ngIf="comparaisonForm.get('coEmprunteurDeplacementProfessionnel')?.invalid && comparaisonForm.get('coEmprunteurDeplacementProfessionnel')?.touched"
                  class="error-message" role="alert">
                  Le déplacement professionnel du co-emprunteur est obligatoire
                </div>
              </div>

              <div class="form-group"
                [ngClass]="{ 'has-error': comparaisonForm.get('coEmprunteurTravailEnHauteur')?.invalid && comparaisonForm.get('coEmprunteurTravailEnHauteur')?.touched }">
                <label for="coEmprunteurTravailEnHauteur" class="form-label">Travail en hauteur co-emprunteur *</label>
                <div class="radio-group" role="radiogroup" aria-labelledby="coEmprunteurTravailEnHauteur-label">
                  <div class="radio-option"
                    *ngFor="let option of coEmprunteurTravailEnHauteurOptions; trackBy: trackByValue">
                    <p-radioButton [inputId]="'co-hauteur-' + option.value" [value]="option.value"
                      formControlName="coEmprunteurTravailEnHauteur"
                      name="coEmprunteurTravailEnHauteur"></p-radioButton>
                    <label [for]="'co-hauteur-' + option.value" class="radio-label"
                      style="margin-left: 0.5rem; cursor: pointer;">
                      {{ option.label }}
                    </label>
                  </div>
                </div>
                <div
                  *ngIf="comparaisonForm.get('coEmprunteurTravailEnHauteur')?.invalid && comparaisonForm.get('coEmprunteurTravailEnHauteur')?.touched"
                  class="error-message" role="alert">
                  Le travail en hauteur du co-emprunteur est obligatoire
                </div>
              </div>
            </div>

            <!-- Deuxième ligne : Checkboxes et encours -->
            <div class="form-row">
              <div class="form-group checkbox-group">
                <p-checkbox formControlName="coEmprunteurportCharge" binary="true"
                  inputId="coEmprunteurportCharge"></p-checkbox>
                <label for="coEmprunteurportCharge">Port de charge</label>
              </div>

              <div class="form-group checkbox-group">
                <p-checkbox formControlName="coEmprunteurFumeur" binary="true"
                  inputId="coEmprunteurFumeur"></p-checkbox>
                <label for="coEmprunteurFumeur">Fumeur</label>
              </div>

              <div class="form-group">
                <label for="coEmprunteurEnCoursTotalAssure">Encours total assuré</label>
                <input pInputText formControlName="coEmprunteurEnCoursTotalAssure" id="coEmprunteurEnCoursTotalAssure"
                  placeholder="150000" type="number" />
              </div>
            </div>
          </fieldset>
        </fieldset>

        <fieldset>
          <legend>Commentaire étape Emprunteur</legend>
          <div class="form-group">
            <label for="commentaireEmprunteur" class="field-label-enhanced">
              <i class="pi pi-comment"></i>
              Commentaire
            </label>
            <textarea id="commentaireEmprunteur" pInputTextarea formControlName="commentaireEmprunteur" rows="3"
              placeholder="Informations complémentaires sur l'emprunteur...">
            </textarea>
          </div>
        </fieldset>
      </div>

      <!-- Étape 2 : Prêt -->
      <div *ngIf="activeStep === 1" class="form-step">
        <fieldset>
          <legend>Informations Prêt Principal</legend>
          <div class="form-row">
            <div class="form-group">
              <label for="typePret" class="field-label-enhanced">
                <i class="pi pi-credit-card"></i>
                Type de prêt *
              </label>
              <p-dropdown formControlName="typePret" [options]="typesPret" placeholder="Sélectionner un type de prêt"
                id="typePret"></p-dropdown>
              <div *ngIf="comparaisonForm.get('typePret')?.invalid && comparaisonForm.get('typePret')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> Le type de prêt est obligatoire
              </div>
            </div>
            <div class="form-group">
              <label for="montant" class="field-label-enhanced">
                <i class="pi pi-money-bill"></i>
                Montant du prêt (CRD) *
              </label>
              <div class="input-with-button">
                <input pInputText formControlName="montant" id="montant" placeholder="200000.00" type="number"
                  step="0.01" />
                <p-button type="button" icon="pi pi-calculator" (onClick)="calculerCRDAutomatique()"
                  styleClass="p-button-outlined p-button-sm" pTooltip="Calculer automatiquement le CRD">
                </p-button>
              </div>
              <div *ngIf="comparaisonForm.get('montant')?.invalid && comparaisonForm.get('montant')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> Le montant du prêt est obligatoire
              </div>
            </div>
          </div>


          <div class="form-row">
            <div class="form-group">
              <label for="taux" class="field-label-enhanced">
                <i class="pi pi-percentage"></i>
                Taux du prêt (%)
              </label>
              <input pInputText formControlName="taux" id="taux" placeholder="1.5" type="number" step="0.01"
                (blur)="onMainTauxBlur()" />
            </div>
            <div class="form-group">
              <label for="duree" class="field-label-enhanced">
                <i class="pi pi-clock"></i>
                Durée restante (mois) *
              </label>
              <div class="input-with-button">
                <input pInputText formControlName="duree" id="duree" placeholder="240" type="number" />
              </div>
              <div *ngIf="comparaisonForm.get('duree')?.invalid && comparaisonForm.get('duree')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> La durée est obligatoire
              </div>
              <div class="duree-auto-calc">
                <label for="dateFinCredit" class="duree-auto-label">
                  <i class="pi pi-calendar-clock"></i>
                  Ou calculer depuis la date de fin du crédit
                </label>
                <div class="input-with-button">
                  <input pInputText id="dateFinCredit" [(ngModel)]="dateFinCredit"
                    [ngModelOptions]="{ standalone: true }" placeholder="Ex: 15122040" appDateFormat maxlength="10" />
                  <p-button type="button" icon="pi pi-calculator" (onClick)="calculerDureeDepuisDateFin()"
                    styleClass="p-button-outlined p-button-sm"
                    pTooltip="Calculer la durée en mois depuis la date d'effet"></p-button>
                </div>
                <small class="duree-auto-hint">Durée = nombre de mois entre la date d'effet (étape 1) et cette
                  date.</small>
              </div>
            </div>
          </div>
          <div *ngIf="showAprilClassicLoanZeroRateWarning" class="bank-info-message warning-message"
            style="color:#e65100;font-weight:bold;margin-bottom:1em;">
            <i class="pi pi-exclamation-triangle"></i>
            Alerte APRIL : pour un prêt classique, le taux du prêt doit être supérieur à 0 (essayer tauxZero svp).
          </div>
          <div class="form-row"
            *ngIf="!isPublicDevisRoute && (comparaisonForm.get('typePret')?.value === 'Classique' || comparaisonForm.get('typePret')?.value === 'PretAPaliers')">
            <div class="form-group">
              <label for="differe" class="field-label-enhanced">
                <i class="pi pi-hourglass"></i>
                Différé (mois)
              </label>
              <input pInputText formControlName="differe" id="differe" placeholder="0" />
              <div *ngIf="comparaisonForm.get('differe')?.invalid && comparaisonForm.get('differe')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> Valeur numérique requise
              </div>
            </div>
            <div class="form-group">
              <label for="typeDiffere" class="field-label-enhanced">
                <i class="pi pi-list"></i>
                Type de différé
              </label>
              <p-dropdown formControlName="typeDiffere" [options]="typesDiffere" placeholder="Sélectionner"
                id="typeDiffere"></p-dropdown>
            </div>
          </div>
          <div *ngIf="comparaisonForm.get('typePret')?.value === 'PretAPaliers'">
            <fieldset>
              <legend>Paliers du prêt</legend>
              <div *ngFor="let palier of paliersFormArray.controls; let i = index" [formGroup]="$any(palier)"
                class="form-row">
                <div class="form-group">
                  <label class="field-label-enhanced">
                    <i class="pi pi-clock"></i>
                    Durée du palier (mois)
                  </label>
                  <input pInputText formControlName="duree" type="number" placeholder="Durée" />
                </div>
                <div class="form-group">
                  <label class="field-label-enhanced">
                    <i class="pi pi-euro"></i>
                    Montant de l'échéance (€)
                  </label>
                  <input pInputText formControlName="montantEcheance" type="number" placeholder="Montant" />
                </div>
                <div class="form-group" style="align-self: end;">
                  <button pButton type="button" icon="pi pi-trash" class="p-button-danger p-button-sm"
                    (click)="supprimerPalier(i)" pTooltip="Supprimer ce palier"></button>
                </div>
              </div>
              <button pButton type="button" label="Ajouter un palier" icon="pi pi-plus" (click)="ajouterPalier()"
                styleClass="p-button-outlined"></button>
            </fieldset>
          </div>
        </fieldset>
        <!-- Champs pour le calcul automatique -->
        <fieldset class="nested-fieldset" *ngIf="showCalculAutoFields">
          <legend>Paramètres pour calcul automatique</legend>
          <div class="form-row">
            <div class="form-group">
              <label for="montantCreditInitial" class="field-label-enhanced">
                <i class="pi pi-money-bill"></i>
                Montant crédit initial *
              </label>
              <input pInputText formControlName="montantCreditInitial" id="montantCreditInitial" placeholder="250000"
                type="number" step="0.01" />
              <div
                *ngIf="comparaisonForm.get('montantCreditInitial')?.invalid && comparaisonForm.get('montantCreditInitial')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> Le montant initial est obligatoire
              </div>
            </div>
            <div class="form-group">
              <label for="datePremierEcheance" class="field-label-enhanced">
                <i class="pi pi-calendar"></i>
                Date 1ère échéance *
              </label>
              <input pInputText formControlName="datePremierEcheance" id="datePremierEcheance" placeholder="jjmmaaaa"
                appDateFormat maxlength="10" />
              <div
                *ngIf="comparaisonForm.get('datePremierEcheance')?.invalid && comparaisonForm.get('datePremierEcheance')?.touched"
                class="error-message">
                <div *ngIf="comparaisonForm.get('datePremierEcheance')?.errors?.['required']"><i
                    class="pi pi-exclamation-circle"></i> La date de première échéance est obligatoire</div>
                <div *ngIf="comparaisonForm.get('datePremierEcheance')?.errors?.['invalidDateFormat']"><i
                    class="pi pi-exclamation-circle"></i> Format invalide. Utilisez JJMMAAAA</div>
                <div *ngIf="comparaisonForm.get('datePremierEcheance')?.errors?.['invalidMonth']"><i
                    class="pi pi-exclamation-circle"></i> Mois invalide (01-12)</div>
                <div *ngIf="comparaisonForm.get('datePremierEcheance')?.errors?.['invalidDay']"><i
                    class="pi pi-exclamation-circle"></i> Jour invalide (01-31)</div>
                <div *ngIf="comparaisonForm.get('datePremierEcheance')?.errors?.['invalidDayForMonth']"><i
                    class="pi pi-exclamation-circle"></i> Jour invalide pour ce mois</div>
                <div *ngIf="comparaisonForm.get('datePremierEcheance')?.errors?.['invalidYear']"><i
                    class="pi pi-exclamation-circle"></i> Année invalide (1900-2100)</div>
                <div *ngIf="comparaisonForm.get('datePremierEcheance')?.errors?.['pastDate']"><i
                    class="pi pi-exclamation-circle"></i> La date doit être dans le futur</div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="dureeInitiale" class="field-label-enhanced">
                <i class="pi pi-clock"></i>
                Durée initiale (mois) *
              </label>
              <input pInputText formControlName="dureeInitiale" id="dureeInitiale" placeholder="300" type="number" />
              <div
                *ngIf="comparaisonForm.get('dureeInitiale')?.invalid && comparaisonForm.get('dureeInitiale')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> La durée initiale est obligatoire
              </div>
            </div>

          </div>
          <div class="form-row">
            <p-button type="button" label="Calculer CRD et Durée" icon="pi pi-calculator"
              (onClick)="calculerCRDEtDuree()" styleClass="p-button-success">
            </p-button>
            <p-button type="button" label="Masquer" icon="pi pi-eye-slash" (onClick)="masquerCalculAuto()"
              styleClass="p-button-text">
            </p-button>
          </div>
        </fieldset>

        <!-- Bouton pour ajouter prêt -->
        <div class="form-actions-inline">
          <p-button type="button" label="Ajouter un prêt" icon="pi pi-plus" (onClick)="ajouterPret()"
            styleClass="p-button-outlined"></p-button>
        </div>

        <!-- Prêts additionnels -->
        <fieldset *ngFor="let pret of pretsAdditionelsFormArray.controls; let i = index"
          class="pret-additionnel-section">
          <div [formGroup]="$any(pret)">
            <legend>
              Prêt {{ i + 2 }}
              <p-button type="button" icon="pi pi-times" (onClick)="supprimerPret(i)"
                styleClass="p-button-text p-button-sm delete-button" pTooltip="Supprimer ce prêt"></p-button>
            </legend>
            <div class="form-row">
              <div class="form-group">
                <label for="typePret{{i}}" class="field-label-enhanced">
                  <i class="pi pi-credit-card"></i>
                  Type de prêt *
                </label>
                <p-dropdown formControlName="typePret" [options]="typesPret" placeholder="Sélectionner un type de prêt"
                  id="typePret{{i}}"></p-dropdown>
              </div>
              <div class="form-group">
                <label for="capitalRestantDu{{i}}" class="field-label-enhanced">
                  <i class="pi pi-money-bill"></i>
                  Capital restant dû *
                </label>
                <div class="input-with-button">
                  <input pInputText formControlName="capitalRestantDu" id="capitalRestantDu{{i}}" placeholder="80000"
                    type="number" step="0.01" />
                  <p-button type="button" icon="pi pi-calculator" (onClick)="calculerCRDAutomatiquePret(i)"
                    styleClass="p-button-outlined p-button-sm" pTooltip="Calculer automatiquement le CRD">
                  </p-button>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <label for="tauxPret{{i}}" class="field-label-enhanced">
                  <i class="pi pi-percentage"></i>
                  Taux du prêt (%)
                </label>
                <input pInputText formControlName="tauxPret" id="tauxPret{{i}}" placeholder="2.1" type="number"
                  step="0.01" (blur)="onAdditionalTauxPretBlur(i)" />
              </div>
              <div class="form-group">
                <label for="dureeRestante{{i}}" class="field-label-enhanced">
                  <i class="pi pi-clock"></i>
                  Durée restante (mois) *
                </label>
                <input pInputText formControlName="dureeRestante" id="dureeRestante{{i}}" placeholder="180"
                  type="number" />
                <div class="duree-auto-calc">
                  <label for="dateFinCredit{{i}}" class="duree-auto-label">
                    <i class="pi pi-calendar-clock"></i>
                    Ou calculer depuis la date de fin du crédit
                  </label>
                  <div class="input-with-button">
                    <input pInputText id="dateFinCredit{{i}}" formControlName="dateFinCredit" placeholder="Ex: 15122040"
                      appDateFormat maxlength="10" />
                    <p-button type="button" icon="pi pi-calculator" (onClick)="calculerDureeDepuisDateFinPret(i)"
                      styleClass="p-button-outlined p-button-sm"
                      pTooltip="Calculer la durée en mois depuis la date d'effet"></p-button>
                  </div>
                  <small class="duree-auto-hint">Durée = nombre de mois entre la date d'effet (étape 1) et cette
                    date.</small>
                </div>
              </div>
            </div>

            <!-- Champs pour le calcul automatique du prêt additionnel -->
            <fieldset class="nested-fieldset" *ngIf="isCalculAutoVisibleForPret(i)">
              <legend>Paramètres pour calcul automatique</legend>
              <div class="form-row">
                <div class="form-group">
                  <label for="montantCreditInitial{{i}}" class="field-label-enhanced">
                    <i class="pi pi-money-bill"></i>
                    Montant crédit initial *
                  </label>
                  <input pInputText formControlName="montantCreditInitial" id="montantCreditInitial{{i}}"
                    placeholder="250000" type="number" step="0.01" />
                  <div *ngIf="pret.get('montantCreditInitial')?.invalid && pret.get('montantCreditInitial')?.touched"
                    class="error-message">
                    <i class="pi pi-exclamation-circle"></i> Le montant initial est obligatoire
                  </div>
                </div>
                <div class="form-group">
                  <label for="datePremierEcheance{{i}}" class="field-label-enhanced">
                    <i class="pi pi-calendar"></i>
                    Date 1ère échéance *
                  </label>
                  <input pInputText formControlName="datePremierEcheance" id="datePremierEcheance{{i}}"
                    placeholder="jjmmaaaa" appDateFormat maxlength="10" />
                  <div *ngIf="pret.get('datePremierEcheance')?.invalid && pret.get('datePremierEcheance')?.touched"
                    class="error-message">
                    <i class="pi pi-exclamation-circle"></i> Format invalide. Utilisez JJMMAAAA
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label for="dureeInitiale{{i}}" class="field-label-enhanced">
                    <i class="pi pi-clock"></i>
                    Durée initiale (mois) *
                  </label>
                  <input pInputText formControlName="dureeInitiale" id="dureeInitiale{{i}}" placeholder="300"
                    type="number" />
                  <div *ngIf="pret.get('dureeInitiale')?.invalid && pret.get('dureeInitiale')?.touched"
                    class="error-message">
                    <i class="pi pi-exclamation-circle"></i> La durée initiale est obligatoire
                  </div>
                </div>
              </div>
              <div class="form-row">
                <p-button type="button" label="Calculer CRD et Durée" icon="pi pi-calculator"
                  (onClick)="calculerCRDEtDureePret(i)" styleClass="p-button-success">
                </p-button>
                <p-button type="button" label="Masquer" icon="pi pi-eye-slash" (onClick)="masquerCalculAutoPret(i)"
                  styleClass="p-button-text">
                </p-button>
              </div>
            </fieldset>
            <div *ngIf="isAdditionalLoanAprilZeroRateWarning(pret)" class="bank-info-message warning-message"
              style="color:#e65100;font-weight:bold;margin-bottom:1em;">
              <i class="pi pi-exclamation-triangle"></i>
              Alerte APRIL : pour un prêt classique, le taux du prêt doit être supérieur à 0 (essayer tauxZero svp).
            </div>
            <div class="form-row"
              *ngIf="!isPublicDevisRoute && (pret.get('typePret')?.value === 'Classique' || pret.get('typePret')?.value === 'PretAPaliers')">
              <div class="form-group">
                <label for="differe{{i}}" class="field-label-enhanced">
                  <i class="pi pi-hourglass"></i>
                  Différé (mois)
                </label>
                <input pInputText formControlName="differe" id="differe{{i}}" placeholder="0" type="number" />
              </div>
              <div class="form-group">
                <label for="typeDiffere{{i}}" class="field-label-enhanced">
                  <i class="pi pi-list"></i>
                  Type de différé
                </label>
                <p-dropdown formControlName="typeDiffere" [options]="typesDiffere" placeholder="Sélectionner"
                  id="typeDiffere{{i}}"></p-dropdown>
              </div>
            </div>

            <!-- Paliers du prêt additionnel -->
            <div *ngIf="pret.get('typePret')?.value === 'PretAPaliers'" formArrayName="paliers">
              <fieldset>
                <legend>Paliers du prêt {{ i + 2 }}</legend>
                <div *ngFor="let palier of paliersPretFormArray(i).controls; let j = index" [formGroupName]="j"
                  class="form-row">
                  <div class="form-group">
                    <label class="field-label-enhanced">
                      <i class="pi pi-clock"></i>
                      Durée du palier (mois)
                    </label>
                    <input pInputText formControlName="duree" type="number" placeholder="Durée" />
                  </div>
                  <div class="form-group">
                    <label class="field-label-enhanced">
                      <i class="pi pi-euro"></i>
                      Montant de l'échéance (€)
                    </label>
                    <input pInputText formControlName="montantEcheance" type="number" placeholder="Montant" />
                  </div>
                  <div class="form-group" style="align-self: end;">
                    <button pButton type="button" icon="pi pi-trash" class="p-button-danger p-button-sm"
                      (click)="supprimerPalierPret(i, j)" pTooltip="Supprimer ce palier"></button>
                  </div>
                </div>
                <button pButton type="button" label="Ajouter un palier" icon="pi pi-plus"
                  (click)="ajouterPalierPret(i)" styleClass="p-button-outlined"></button>
              </fieldset>
            </div>
          </div>
        </fieldset>

        <fieldset>
          <legend>Commentaire étape Prêt</legend>
          <div class="form-group">
            <label for="commentairePret" class="field-label-enhanced">
              <i class="pi pi-comment"></i>
              Commentaire
            </label>
            <textarea id="commentairePret" pInputTextarea formControlName="commentairePret" rows="3"
              placeholder="Informations complémentaires sur le prêt...">
            </textarea>
          </div>
        </fieldset>
      </div>


      <!-- Étape 3 : Garanties de l'emprunteur -->
      <div *ngIf="activeStep === 2" class="form-step">
        <fieldset>
          <legend>Garanties de l'emprunteur principal</legend>
          <div class="form-row">
            <div class="form-group">
              <label for="quotite" class="field-label-enhanced">
                <i class="pi pi-chart-pie"></i>
                Quotité (%) *
              </label>
              <input pInputText formControlName="quotite" id="quotite" placeholder="100" type="number" min="0"
                max="100" />
              <div *ngIf="comparaisonForm.get('quotite')?.invalid && comparaisonForm.get('quotite')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> La quotité est obligatoire (0-100%)
              </div>
            </div>
            <div class="form-group">
              <label for="franchiseITT" class="field-label-enhanced">
                <i class="pi pi-shield"></i>
                Franchise ITT *
              </label>
              <p-dropdown formControlName="franchiseITT" [options]="franchisesITT"
                placeholder="Sélectionner une franchise" id="franchiseITT"></p-dropdown>
              <div *ngIf="comparaisonForm.get('franchiseITT')?.invalid && comparaisonForm.get('franchiseITT')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> La franchise ITT est obligatoire
              </div>
            </div>
          </div>
          <div *ngIf="isMedicalProfession()" style="color:#d32f2f;font-weight:bold;margin-bottom:1em;">
            ATTENTION : Professions médicales ou paramédicales détectées.<br>
            🡺 Pensez à proposer l’IPPRO à votre client.
          </div>
          <div *ngIf="agePlus2Mois !== null">
            <div *ngIf="showPtiaWarning" style="color:#d32f2f;font-weight:bold;margin-bottom:1em;">
              ATTENTION : Garantie PTIA non possible normalement pour APRIL (age>=65ans)
            </div>
            <div *ngIf="showIttIptWarning" style="color:#d32f2f;font-weight:bold;margin-bottom:1em;">
              ATTENTION : Garantie ITT/IPT non possibles normalement
            </div>
          </div>
          <fieldset class="nested-fieldset">
            <legend>Garanties souscrites</legend>
            <div class="checkbox-grid">
              <div class="form-group checkbox-group">
                <p-checkbox formControlName="quotiteDC" binary="true" inputId="quotiteDC" [disabled]="true"
                  styleClass="checkbox-grey"></p-checkbox>
                <label for="quotiteDC" class="field-label-enhanced" style="margin-bottom: 0;">
                  Décès
                </label>
              </div>
              <div class="form-group checkbox-group">
                <p-checkbox formControlName="quotitePTIA" binary="true" inputId="quotitePTIA" [disabled]="ptiaDisabled"
                  styleClass="checkbox-grey">
                </p-checkbox>
                <label for="quotitePTIA" class="field-label-enhanced" style="margin-bottom: 0;">
                  PTIA
                </label>
              </div>
              <div class="form-group checkbox-group">
                <p-checkbox formControlName="quotiteITT" binary="true" inputId="quotiteITT"></p-checkbox>
                <label for="quotiteITT" class="field-label-enhanced" style="margin-bottom: 0;">
                  ITT
                </label>
              </div>
              <div class="form-group checkbox-group">
                <p-checkbox formControlName="quotiteIPT" binary="true" inputId="quotiteIPT"></p-checkbox>
                <label for="quotiteIPT" class="field-label-enhanced" style="margin-bottom: 0;">
                  IPT
                </label>
              </div>
              <div class="form-group checkbox-group">
                <p-checkbox formControlName="quotiteIPP" binary="true" inputId="quotiteIPP"></p-checkbox>
                <label for="quotiteIPP" class="field-label-enhanced" style="margin-bottom: 0;">
                  IPP
                </label>
              </div>
              <div *ngIf="shouldShowIPPCreditAvant2020Message()" class="bank-info-message warning-message"
                style="color:#e65100;font-weight:bold;font-size:0.85em;margin-top:-0.5em;margin-bottom:0.5em;grid-column:1/-1;">
                <i class="pi pi-info-circle"></i> Si Crédit signé avant 2020 alors pas d'IPP
              </div>
              <div class="form-group checkbox-group">
                <p-checkbox formControlName="quotiteIPPRO" binary="true" inputId="quotiteIPPRO"></p-checkbox>
                <label for="quotiteIPPRO" class="field-label-enhanced" style="margin-bottom: 0;">
                  IPPRO
                </label>
              </div>
            </div>
          </fieldset>
          <fieldset class="nested-fieldset">
            <legend>Exclusions et options</legend>
            <div class="checkbox-grid">
              <div class="form-group checkbox-group" *ngIf="showDosPsy">
                <p-checkbox formControlName="mauxDos" binary="true" inputId="mauxDos"></p-checkbox>
                <label for="mauxDos" class="field-label-enhanced" style="margin-bottom: 0;">
                  Maux de dos couverts
                </label>
              </div>
              <div class="form-group checkbox-group" *ngIf="showDosPsy">
                <p-checkbox formControlName="psy" binary="true" inputId="psy"></p-checkbox>
                <label for="psy" class="field-label-enhanced" style="margin-bottom: 0;">
                  Troubles psychiques couverts
                </label>
              </div>
            </div>
          </fieldset>
          <div class="form-row">

            <div class="form-group">
              <label for="fraisCourtage" class="field-label-enhanced">
                <i class="pi pi-euro"></i>
                Frais de courtage
              </label>
              <input pInputText formControlName="fraisCourtage" id="fraisCourtage" placeholder="100" />
              <div
                *ngIf="comparaisonForm.get('fraisCourtage')?.invalid && comparaisonForm.get('fraisCourtage')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> Valeur numérique requise
              </div>
            </div>
          </div>



          <div class="form-group">
            <label for="commentaireGaranties" class="field-label-enhanced">
              <i class="pi pi-comment"></i>
              Commentaire
            </label>
            <textarea id="commentaireGaranties" pInputTextarea formControlName="commentaireGaranties" rows="3"
              placeholder="Informations complémentaires..."></textarea>
          </div>
        </fieldset>

        <!-- Section garanties co-emprunteur -->
        <fieldset *ngIf="showCoEmprunteur" class="co-emprunteur-garanties">
          <legend>Garanties du co-emprunteur</legend>
          <div class="form-row">
            <div class="form-group">
              <label for="coEmprunteurQuotite">Quotité (%) *</label>
              <input pInputText formControlName="coEmprunteurQuotite" id="coEmprunteurQuotite" placeholder="100"
                type="number" min="0" max="100" />
              <div
                *ngIf="comparaisonForm.get('coEmprunteurQuotite')?.invalid && comparaisonForm.get('coEmprunteurQuotite')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> La quotité est obligatoire (1-100%)
              </div>
            </div>
            <div class="form-group">
              <label for="coEmprunteurFranchiseITT">Franchise ITT *</label>
              <p-dropdown formControlName="coEmprunteurFranchiseITT" [options]="franchisesITT"
                placeholder="Sélectionner une franchise" id="coEmprunteurFranchiseITT"></p-dropdown>
              <div
                *ngIf="comparaisonForm.get('coEmprunteurFranchiseITT')?.invalid && comparaisonForm.get('coEmprunteurFranchiseITT')?.touched"
                class="error-message">
                <i class="pi pi-exclamation-circle"></i> La franchise ITT est obligatoire
              </div>
            </div>
          </div>
          <div *ngIf="showCoEmprunteurPtiaWarning" style="color:#d32f2f;font-weight:bold;margin-bottom:1em;">
            ATTENTION : Garantie PTIA non possible normalement pour APRIL (age>=65ans)
          </div>
          <div *ngIf="showCoEmprunteurIttIptWarning" style="color:#d32f2f;font-weight:bold;margin-bottom:1em;">
            ATTENTION : Garantie ITT/IPT non possibles normalement
          </div>
          <fieldset class="nested-fieldset">
            <legend>Garanties souscrites</legend>
            <div class="checkbox-grid">
              <div class="form-group checkbox-group">
                <p-checkbox formControlName="coEmprunteurQuotiteDC" binary="true" inputId="coEmprunteurQuotiteDC"
                  [disabled]="true" styleClass="checkbox-grey"></p-checkbox>
                <label for="coEmprunteurQuotiteDC">Décès</label>
              </div>
              <div class="form-group checkbox-group">
                <p-checkbox formControlName="coEmprunteurQuotitePTIA" binary="true" inputId="coEmprunteurQuotitePTIA"
                  [disabled]="coEmprunteurPtiaDisabled" styleClass="checkbox-grey"></p-checkbox>
                <label for="coEmprunteurQuotitePTIA">PTIA</label>
              </div>
              <div class="form-group checkbox-group">
                <p-checkbox formControlName="coEmprunteurQuotiteITT" binary="true"
                  inputId="coEmprunteurQuotiteITT"></p-checkbox>
                <label for="coEmprunteurQuotiteITT">ITT</label>
              </div>
              <div class="form-group checkbox-group">
                <p-checkbox formControlName="coEmprunteurQuotiteIPT" binary="true"
                  inputId="coEmprunteurQuotiteIPT"></p-checkbox>
                <label for="coEmprunteurQuotiteIPT">IPT</label>
              </div>
              <div class="form-group checkbox-group">
                <p-checkbox formControlName="coEmprunteurQuotiteIPP" binary="true"
                  inputId="coEmprunteurQuotiteIPP"></p-checkbox>
                <label for="coEmprunteurQuotiteIPP">IPP</label>
              </div>
              <div class="form-group checkbox-group">
                <p-checkbox formControlName="coEmprunteurQuotiteIPPRO" binary="true"
                  inputId="coEmprunteurQuotiteIPPRO"></p-checkbox>
                <label for="coEmprunteurQuotiteIPPRO">IPPRO</label>
              </div>
            </div>
          </fieldset>
          <fieldset class="nested-fieldset">
            <legend>Exclusions et options</legend>
            <div class="checkbox-grid">
              <div class="form-group checkbox-group" *ngIf="showCoEmprunteurDosPsy">
                <p-checkbox formControlName="coEmprunteurMauxDos" binary="true"
                  inputId="coEmprunteurMauxDos"></p-checkbox>
                <label for="coEmprunteurMauxDos">Maux de dos couverts</label>
              </div>
              <div class="form-group checkbox-group" *ngIf="showCoEmprunteurDosPsy">
                <p-checkbox formControlName="coEmprunteurPsy" binary="true" inputId="coEmprunteurPsy"></p-checkbox>
                <label for="coEmprunteurPsy">Troubles psychiques couverts</label>
              </div>
            </div>
          </fieldset>
          <div class="form-row">
            <div class="form-group">
              <label for="coEmprunteurFraisCourtage">Frais de courtage</label>
              <input pInputText formControlName="coEmprunteurFraisCourtage" id="coEmprunteurFraisCourtage"
                placeholder="100" />
            </div>
          </div>
        </fieldset>
      </div>

      <!-- ÉTAPE 5 : RÉSULTATS & COMPARATEUR -->
      <div *ngIf="!isPublicDevisRoute && activeStep === 3" class="form-step">
        <div class="section-title section-title-results">
          <i class="pi pi-chart-bar"></i>
          <span class="section-title-main">Résultats de la comparaison</span>
          <span class="section-title-meta">- {{ comparisonHeaderIdentity }} - {{ comparisonHeaderMontant }} - {{
            comparisonHeaderDuree }}</span>
        </div>

        <div
          *ngIf="result && (result.utwin || result.april || result.cardif || result.neoliane || result.afiesca || result.lifesquare || result.zenioo)"
          class="results-section">
          <div class="results-main">
            <div *ngIf="isBanqueCotisationConstante()" style="margin-bottom: 1em; color: #1976d2; font-weight: bold;">
              Informations banque : pour cette banque, les cotisations côté client sont en cotisation constante.
              Veillez à en tenir compte dans votre présentation des résultats.
            </div>
            <div *ngIf="isBanqueCotisationFixe()" class="bank-alert-banner"
              style="margin-bottom: 1em; padding: 0.75em 1em; background: #e3f2fd; border-left: 4px solid #1565c0; border-radius: 4px; color: #0d47a1; font-weight: bold;">
              <i class="pi pi-info-circle"></i> {{ getBanqueCotisationFixeMessage() }}
            </div>
            <div *ngIf="isBanquePriseEnChargeIndemnitaire()" class="bank-alert-banner"
              style="margin-bottom: 1em; padding: 0.75em 1em; background: #fff3e0; border-left: 4px solid #e65100; border-radius: 4px; color: #bf360c; font-weight: bold;">
              <i class="pi pi-info-circle"></i> Prise en charge indemnitaire
            </div>
            <div *ngIf="isBanqueExtensionGarantieITT()" class="bank-alert-banner"
              style="margin-bottom: 1em; padding: 0.75em 1em; background: #e8f5e9; border-left: 4px solid #2e7d32; border-radius: 4px; color: #1b5e20; font-weight: bold;">
              <i class="pi pi-shield"></i> Fin de garantie ITT à 67 ans (Extension Garantie). Pour CARDIF : 71 ans pour
              les contrats commercialisés après 2020.
            </div>
            <div *ngIf="showLemoineZeniooAlert" class="bank-alert-banner"
              style="margin-bottom: 1em; padding: 1rem; background: #fff7ed; border-left: 4px solid #ea580c; border-radius: 4px; color: #9a3412;">
              <div style="display: flex; flex-direction: column; gap: 0.85rem;">
                <div style="font-weight: 700; display: flex; align-items: center; gap: 0.5rem;">
                  <i class="pi pi-exclamation-triangle"></i>
                  <span>Attention – Profil Lemoine détecté</span>
                </div>
                <div style="line-height: 1.5;">
                  Les offres MNCAP 1021 et MNCAP 0124 ne sont éligibles que si l'emprunteur n'a jamais effectué de
                  changement d'assurance via la loi Lemoine sur ce prêt. Veuillez demander au client s'il a déjà changé
                  d'assurance. Si oui, ces produits doivent être exclus des résultats.
                </div>
                <div style="display: flex; gap: 0.75rem; flex-wrap: wrap;">
                  <p-button type="button" label="Le client n'a jamais changé" severity="success"
                    (onClick)="handleLemoineZeniooDecision(false)">
                  </p-button>
                  <p-button type="button" label="Le client a déjà changé" severity="danger"
                    (onClick)="handleLemoineZeniooDecision(true)">
                  </p-button>
                </div>
              </div>
            </div>
            <div class="products-summary">
              <div class="summary-line">
                <p class="summary-text">
                  <strong>{{ getFilteredProducts().length }}</strong> formules répondent à vos critères de filtrage
                  parmi les <strong>{{ getAllProductsSortedByPrice().length }}</strong> formules disponibles.
                </p>
                <div class="summary-sort-inline" role="radiogroup" aria-label="Tri des résultats">
                  <span class="summary-sort-inline-label">Tri :</span>

                  <div class="summary-sort-inline-option">
                    <p-radioButton inputId="sort-total-inline" name="resultSortModeInline" [value]="'total'"
                      [ngModel]="resultSortMode" [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="setResultSortMode($event)">
                    </p-radioButton>
                    <label for="sort-total-inline">Cotisation totale</label>
                  </div>

                  <div class="summary-sort-inline-option">
                    <p-radioButton inputId="sort-monthly-inline" name="resultSortModeInline" [value]="'monthly'"
                      [ngModel]="resultSortMode" [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="setResultSortMode($event)">
                    </p-radioButton>
                    <label for="sort-monthly-inline">Cotisation mensuelle</label>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="canManageCommissions" class="results-actions" style="margin-bottom: 1rem;">
              <p-button type="button" [label]="showCommissionPanel ? 'Masquer commissions' : 'Modifier commissions'"
                [icon]="showCommissionPanel ? 'pi pi-chevron-up' : 'pi pi-sliders-h'" styleClass="p-button-outlined"
                (onClick)="toggleCommissionPanel()">
              </p-button>
            </div>

            <!-- Panneau de modification des commissions -->
            <div *ngIf="canManageCommissions && showCommissionPanel" class="commission-panel">
              <div class="commission-panel-header">
                <h4><i class="pi pi-sliders-h"></i> Modifier les taux de commission</h4>
                <p class="commission-panel-subtitle">Ajustez les commissions pour chaque assureur et relancez la
                  comparaison</p>
              </div>

              <div class="commission-courtage-grid">
                <div class="commission-courtage-field">
                  <label for="commissionFraisCourtage">Frais de courtage</label>
                  <input pInputText id="commissionFraisCourtage" class="commission-courtage-input"
                    [ngModel]="commissionFraisCourtageValue" [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onCommissionFraisCourtageChange($event)" [disabled]="loading" inputmode="numeric"
                    placeholder="0" />
                </div>

                <div class="commission-courtage-field" *ngIf="showCoBorrowerCourtageField">
                  <label for="commissionCoFraisCourtage">Frais de courtage co-emprunteur</label>
                  <input pInputText id="commissionCoFraisCourtage" class="commission-courtage-input"
                    [ngModel]="commissionCoFraisCourtageValue" [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onCommissionCoFraisCourtageChange($event)" [disabled]="loading" inputmode="numeric"
                    placeholder="0" />
                </div>
              </div>

              <div *ngIf="commissionLoading" class="commission-loading">
                <i class="pi pi-spin pi-spinner"></i> Chargement...
              </div>

              <div *ngIf="!commissionLoading && commissionDataLoaded" class="commission-grid">
                <div *ngFor="let item of commissionItems; trackBy: trackByKey" class="commission-item">
                  <div class="commission-insurer">
                    <img [src]="item.logo" [alt]="item.label" class="commission-logo" />
                    <span class="commission-insurer-name">{{ item.label }}</span>
                  </div>
                  <div class="commission-selector">
                    <select class="commission-select" [ngModel]="item.selectedValue"
                      [ngModelOptions]="{ standalone: true }" (ngModelChange)="onCommissionSelect(item, $event)"
                      [disabled]="loading">
                      <option *ngFor="let opt of item.options" [ngValue]="opt.value">
                        {{ opt.label }}
                      </option>
                    </select>
                    <span *ngIf="isItemChanged(item)" class="commission-changed-badge" pTooltip="Valeur modifiée">
                      <i class="pi pi-exclamation-circle"></i>
                    </span>
                  </div>
                </div>
              </div>

              <div class="commission-actions">
                <p-button type="button" label="Réinitialiser" icon="pi pi-refresh"
                  styleClass="p-button-secondary p-button-text" (onClick)="resetCommissions()"
                  [disabled]="!hasChanges || loading">
                </p-button>
                <p-button type="button" label="Relancer la comparaison" icon="pi pi-sync"
                  (onClick)="rerunWithNewCommissions()" [disabled]="!hasChanges || loading" [loading]="loading">
                </p-button>
              </div>
            </div>
            <div class="products-grid">
              <ng-container *ngFor="let product of getFilteredProducts(); let i = index">
                <!-- Produit April -->
                <ng-container *ngIf="product.type === 'april'">
                  <div class="result-box april-product" [class.best-price]="i === 0">
                    <div class="product-left">
                      <div class="logo-section">
                        <img src="assets/images/logos/april-logo.png" alt="April Logo" class="logo-img" />
                      </div>
                      <div class="product-badges">
                        <div class="product-badge product-badge-com">
                          COM / {{ getProductCommissionValue(product) }}
                        </div>
                        <div class="product-badge product-badge-ipt">
                          IPT / {{ getProductCompensationMode(product) }}
                        </div>
                        <div *ngIf="product.hasWarnings" class="product-badge product-badge-warning"
                          pTooltip="Ce produit a des garanties partielles. Voir les détails." tooltipPosition="top">
                          <i class="pi pi-exclamation-triangle"></i> Garanties partielles
                        </div>
                      </div>
                      <h4 class="product-title-main">{{ product.productName }}</h4>
                      <div class="product-subtitle">{{ product.contributionType || 'Cotisation Variable' }}</div>
                    </div>
                    <div class="product-right">
                      <div class="product-price">
                        <ng-container *ngIf="hasAprilProductPricing(product); else noAprilVisiblePricing">
                          <div class="price-main">{{ product.monthlyPrice | number:'1.2-2' }}€</div>
                          <div class="price-label">
                            {{ product.isAprilMixedOffer ? 'mois couple' : 'mois' }} <sup>(1)</sup>
                          </div>
                          <div class="price-secondary">
                            {{ product.firstYearPrice | number:'1.2-2' }}€ <sup>(2)</sup>
                          </div>
                          <div class="price-secondary">{{ product.eightYearsPrice | number:'1.2-2' }}€ <sup>(3)</sup>
                          </div>
                          <div class="price-secondary">
                            <ng-container *ngIf="getAprilDisplayedTaea(product) !== null; else noAprilVisibleTaea">
                              {{ getAprilDisplayedTaea(product) | number:'1.2-2' }}% <sup>(4)</sup>
                            </ng-container>
                            <ng-template #noAprilVisibleTaea>- <sup>(4)</sup></ng-template>
                          </div>
                        </ng-container>
                        <ng-template #noAprilVisiblePricing>
                          <div class="price-main april-unavailable-price">Non tarifable</div>
                          <div class="price-label">Retour métier APRIL</div>
                          <div class="price-secondary">- <sup>(2)</sup></div>
                          <div class="price-secondary">- <sup>(3)</sup></div>
                          <div class="price-secondary">- <sup>(4)</sup></div>
                        </ng-template>
                      </div>
                      <div class="product-details" [class.april-mixed-details]="product.isAprilMixedOffer">
                        <ng-container *ngIf="product.isAprilMixedOffer; else standardAprilDetails">
                          <div class="detail-item april-mixed-detail-item">
                            <span class="detail-label">Emprunteur :</span>
                            <span class="detail-value april-mixed-detail-value">
                              <span class="april-mixed-product-name">{{ product.aprilMainProductName }}</span>
                              <span class="april-mixed-product-price">
                                {{ getAprilMixedOfferTotal(product, 'main') | number:'1.2-2' }} €
                              </span>
                              <span class="april-mixed-monthly">
                                ({{ getAprilMixedOfferMonthly(product, 'main') | number:'1.2-2' }} € / mois)
                              </span>
                            </span>
                          </div>
                          <div class="detail-item april-mixed-detail-item">
                            <span class="detail-label">Co-emprunteur :</span>
                            <span class="detail-value april-mixed-detail-value">
                              <span class="april-mixed-product-name">{{ product.aprilCoProductName }}</span>
                              <span class="april-mixed-product-price">
                                {{ getAprilMixedOfferTotal(product, 'co') | number:'1.2-2' }} €
                              </span>
                              <span class="april-mixed-monthly">
                                ({{ getAprilMixedOfferMonthly(product, 'co') | number:'1.2-2' }} € / mois)
                              </span>
                            </span>
                          </div>
                          <div class="detail-item april-mixed-detail-item">
                            <span class="detail-label">Cotisation :</span>
                            <span class="detail-value april-mixed-detail-value">{{ product.contributionType }}</span>
                          </div>
                          <div class="detail-item april-mixed-detail-item">
                            <span class="detail-label">IPT :</span>
                            <span class="detail-value april-mixed-detail-value">
                              {{ getAprilMixedOfferCompensationSummary(product) }}
                            </span>
                          </div>
                        </ng-container>
                        <ng-template #standardAprilDetails>
                          <div class="detail-item">
                            <span class="detail-label">Couverture de la garantie décès pendant toute la durée du
                              prêt:</span>
                            <span class="detail-value age">jusqu'à 91 ans</span>
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">Couverture de la garantie PTIA pendant toute la durée du
                              prêt:</span>
                            <span class="detail-value age">jusqu'à 71 ans</span>
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">Couverture de la garantie incapacité pendant toute la durée du
                              prêt:</span>
                            <span class="detail-value age">jusqu'à 65 ans</span>
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">Couverture de la garantie invalidité pendant toute la durée du
                              prêt:</span>
                            <span class="detail-value age">jusqu'à 65 ans</span>
                          </div>
                        </ng-template>
                      </div>
                      <div class="product-actions">
                        <button pButton type="button" class="devis-icon-btn" pTooltip="Voir les détails"
                          icon="pi pi-search"></button>
                        <button *ngIf="hasAprilProductBusinessMessages(product)" pButton type="button"
                          class="devis-icon-btn april-alert-btn" pTooltip="Voir les alertes APRIL"
                          icon="pi pi-exclamation-triangle" (click)="openAprilBusinessMessagesDialog(product)">
                        </button>
                        <button pButton type="button" class="devis-icon-btn"
                          [pTooltip]="isProductSelected(product) ? 'Retirer de la sélection' : 'Ajouter à la sélection'"
                          [icon]="isProductSelected(product) ? 'pi pi-check' : 'pi pi-plus'"
                          (click)="toggleProductSelection(product)"
                          [disabled]="!isAprilProductActionable(product)"></button>
                        <button pButton type="button" class="devis-icon-btn" pTooltip="Télécharger le PDF April"
                          icon="pi pi-file-pdf" (click)="genererPdfApril(product)"
                          [disabled]="loading || !isAprilProductActionable(product)"></button>
                        <button pButton type="button" class="devis-icon-btn" pTooltip="Envoyer par mail"
                          (click)="genererDevisApril(product)" icon="pi pi-envelope"
                          [disabled]="!isAprilProductActionable(product)"></button>
                        <button pButton type="button" class="devis-icon-btn" pTooltip="Créer projet April (Extranet)"
                          icon="pi pi-external-link" (click)="creerProjetApril(product)"
                          [disabled]="loading || !isAprilProductActionable(product)"></button>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <!-- Produit Cardif -->
                <ng-container *ngIf="product.type === 'cardif'">
                  <div class="result-box cardif-product" [class.best-price]="i === 0">
                    <div class="product-left">
                      <div class="logo-section">
                        <img src="assets/images/logos/cardif-logo.png" alt="Cardif Logo" class="logo-img" />
                      </div>
                      <div class="product-badges">
                        <div class="product-badge product-badge-com">
                          COM / {{ getProductCommissionValue(product) }}
                        </div>
                        <div class="product-badge product-badge-ipt">
                          IPT / {{ getProductCompensationMode(product) }}
                        </div>
                        <div *ngIf="product.data?.eligible === false" class="product-badge"
                          style="background: #b91c1c; color: #ffffff;">
                          Non éligible
                        </div>
                      </div>
                      <h4 class="product-title-main">{{ product.productName }}</h4>
                      <div class="product-subtitle">
                        {{ product.contributionType }}
                      </div>
                    </div>
                    <div class="product-right">
                      <div class="product-price">
                        <div class="price-main">
                          {{ product.monthlyPrice | number:'1.2-2' }} €
                        </div>
                        <div class="price-label">Cotisation mensuelle</div>
                        <div class="price-secondary" *ngIf="product.firstYearPrice">
                          Coût total : {{ product.firstYearPrice | number:'1.2-2' }} €
                        </div>
                        <div class="price-secondary" *ngIf="product.eightYearsPrice">
                          {{ product.data?.xPremieresAnnees || 8 }} premières années : {{ product.eightYearsPrice |
                          number:'1.2-2' }} €
                        </div>
                        <div class="price-secondary" *ngIf="product.data?.tauxMoyen">
                          Taux moyen : {{ product.data.tauxMoyen | number:'1.3-3' }} %
                        </div>
                      </div>
                      <div class="product-details">
                        <div class="detail-item">
                          <span class="detail-label">Couverture de la garantie décès pendant toute la durée du
                            prêt:</span>
                          <span class="detail-value age">jusqu'à 90 ans </span>
                        </div>
                        <div class="detail-item">
                          <span class="detail-label">Couverture de la garantie PTIA pendant toute la durée du
                            prêt:</span>
                          <span class="detail-value age">jusqu'à 65 ans</span>
                        </div>
                        <div class="detail-item">
                          <span class="detail-label">Couverture de la garantie Incapacité pendant toute la durée du
                            prêt:</span>
                          <span class="detail-value age">jusqu'à 65 ans</span>
                        </div>
                        <div class="detail-item">
                          <span class="detail-label">Couverture de la garantie Invalidité pendant toute la durée du
                            prêt:</span>
                          <span class="detail-value age">jusqu'à 65 ans</span>
                        </div>
                      </div>
                      <div class="product-actions">
                        <button pButton type="button" class="devis-icon-btn" pTooltip="Voir les détails"
                          icon="pi pi-search"></button>
                        <button pButton type="button" class="devis-icon-btn"
                          [pTooltip]="isProductSelected(product) ? 'Retirer de la sélection' : 'Ajouter à la sélection'"
                          [icon]="isProductSelected(product) ? 'pi pi-check' : 'pi pi-plus'"
                          (click)="toggleProductSelection(product)"></button>

                        <button pButton type="button" class="devis-icon-btn"
                          pTooltip="Générer le devis Cardif (PDF + Email)"
                          (click)="genererDevisCardif(product.data.codeProduit)" icon="pi pi-file-pdf"
                          [disabled]="loading">
                        </button>
                        <button pButton type="button" class="devis-icon-btn" icon="pi pi-envelope">
                        </button>
                        <button pButton type="button" class="devis-icon-btn"
                          pTooltip="Souscrire - Accéder au formulaire Cardif Sésame" icon="pi pi-external-link"
                          (click)="souscrireCardif(product)" [disabled]="cardifLoading"
                          style="background-color: #2c5282; color: white;">
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <!-- Produit Utwin -->
                <ng-container *ngIf="product.type === 'utwin'">
                  <div class="result-box utwin-product" [class.best-price]="i === 0">
                    <div class="product-left">
                      <div class="logo-section">
                        <img src="assets/images/logos/utwin-logo.png" alt="Utwin Logo" class="logo-img" />
                      </div>
                      <div class="product-badges">
                        <div class="product-badge product-badge-com">
                          COM / {{ getProductCommissionValue(product) }}
                        </div>
                        <div class="product-badge product-badge-ipt">
                          IPT / {{ getProductCompensationMode(product) }}
                        </div>
                      </div>
                      <h4 class="product-title-main">{{ product.productName }}</h4>
                      <div class="product-subtitle">{{ product.contributionType || 'Cotisation Variable' }}</div>
                    </div>
                    <div class="product-right">
                      <div class="product-price">
                        <div class="price-main">{{ product.monthlyPrice | number:'1.2-2' }}€</div>
                        <div class="price-label">mois <sup>(1)</sup></div>
                        <div class="price-secondary">{{ product.firstYearPrice | number:'1.2-2' }}€ <sup>(2)</sup></div>
                        <div class="price-secondary">{{ product.eightYearsPrice | number:'1.2-2' }}€ <sup>(3)</sup>
                        </div>
                        <div class="price-secondary">{{ product.data.taea | number:'1.2-2' }}% <sup>(4)</sup></div>
                      </div>
                      <div class="product-details">
                        <div class="detail-item">
                          <span class="detail-label">Couverture de la garantie décès pendant toute la durée du
                            prêt:</span>
                          <span class="detail-value age">jusqu'à 91 ans</span>
                        </div>
                        <div class="detail-item">
                          <span class="detail-label">Couverture de la garantie PTIA pendant toute la durée du
                            prêt:</span>
                          <span class="detail-value age">jusqu'à 71 ans</span>
                        </div>
                        <div class="detail-item">
                          <span class="detail-label">Couverture de la garantie incapacité pendant toute la durée du
                            prêt:</span>
                          <span class="detail-value age">jusqu'à 65 ans</span>
                        </div>
                        <div class="detail-item">
                          <span class="detail-label">Couverture de la garantie invalidité pendant toute la durée du
                            prêt:</span>
                          <span class="detail-value age">jusqu'à 65 ans</span>
                        </div>
                      </div>
                      <div class="product-actions">
                        <button pButton type="button" class="devis-icon-btn" pTooltip="Voir les détails"
                          icon="pi pi-search"></button>
                        <button pButton type="button" class="devis-icon-btn"
                          [pTooltip]="isProductSelected(product) ? 'Retirer de la sélection' : 'Ajouter à la sélection'"
                          [icon]="isProductSelected(product) ? 'pi pi-check' : 'pi pi-plus'"
                          (click)="toggleProductSelection(product)"></button>
                        <button pButton type="button" icon="pi pi-file-pdf"
                          (click)="downloadUtwinPdf(product.data?.RefSimu)"
                          [disabled]="loading || !product.data?.RefSimu">
                        </button>
                        <button pButton type="button" icon="pi pi-envelope"
                          (click)="genererDevisUtwin(product.data.RefSimu)"
                          [disabled]="!product.data?.RefSimu || loading">
                        </button>
                        <button pButton type="button" class="devis-icon-btn"
                          pTooltip="Souscrire - Accéder à l'extranet courtier UTWIN" icon="pi pi-external-link"
                          (click)="souscrireUtwin(product)" style="background-color: #2c5282; color: white;">
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <!-- ✅ NOUVEAU : Produit Neoliane -->
                <ng-container *ngIf="product.type === 'neoliane'">
                  <div class="result-box neoliane-product" [class.best-price]="i === 0">
                    <div class="product-left">
                      <div class="logo-section">
                        <img src="assets/images/logos/neoliane-logo.png" alt="Neoliane Logo" class="logo-img" />
                      </div>
                      <div class="product-badges">
                        <div class="product-badge product-badge-com">
                          COM / {{ getProductCommissionValue(product) }}
                        </div>
                        <div class="product-badge product-badge-ipt">
                          IPT / {{ getProductCompensationMode(product) }}
                        </div>
                      </div>
                      <h4 class="product-title-main">{{ product.productName }}</h4>
                      <div class="product-subtitle">{{ product.contributionType || 'Cotisation Variable' }}</div>
                    </div>

                    <div class="product-right">
                      <div class="product-price">
                        <div class="price-main">{{ product.monthlyPrice | number:'1.2-2' }}€</div>
                        <div class="price-label">mois <sup>(1)</sup></div>
                        <div class="price-secondary">{{ product.firstYearPrice | number:'1.2-2' }}€ <sup>(2)</sup></div>
                        <div class="price-secondary">{{ product.eightYearsPrice | number:'1.2-2' }}€ <sup>(3)</sup>
                        </div>
                        <div class="price-secondary">{{ product.data?.taea | number:'1.2-2' }}% <sup>(4)</sup></div>
                      </div>

                      <div class="product-details">
                        <div class="detail-item">
                          <span class="detail-label">Couverture de la garantie décès pendant toute la durée du
                            prêt:</span>
                          <span class="detail-value age">jusqu'à 90 ans</span>
                        </div>
                        <div class="detail-item">
                          <span class="detail-label">Couverture de la garantie PTIA pendant toute la durée du
                            prêt:</span>
                          <span class="detail-value age">jusqu'à 65 ans</span>
                        </div>
                        <div class="detail-item">
                          <span class="detail-label">Couverture de la garantie incapacité pendant toute la durée du
                            prêt:</span>
                          <span class="detail-value age">jusqu'à 65 ans</span>
                        </div>
                        <div class="detail-item">
                          <span class="detail-label">Couverture de la garantie invalidité pendant toute la durée du
                            prêt:</span>
                          <span class="detail-value age">jusqu'à 65 ans</span>
                        </div>
                      </div>

                      <div class="product-actions">
                        <button pButton type="button" class="devis-icon-btn" pTooltip="Voir les détails"
                          icon="pi pi-search">
                        </button>
                        <button pButton type="button" class="devis-icon-btn"
                          [pTooltip]="isProductSelected(product) ? 'Retirer de la sélection' : 'Ajouter à la sélection'"
                          [icon]="isProductSelected(product) ? 'pi pi-check' : 'pi pi-plus'"
                          (click)="toggleProductSelection(product)">
                        </button>
                        <button pButton type="button" class="devis-icon-btn" icon="pi pi-file-pdf"
                          (click)="genererDevisNeoliane(product)"
                          [disabled]="neolianeLoading || !product.data?.eligible"
                          pTooltip="Télécharger le devis Neoliane">
                        </button>
                        <button pButton type="button" class="devis-icon-btn"
                          pTooltip="Documents disponibles ({{ product.data?.documents || 0 }})" icon="pi pi-folder-open"
                          (click)="voirDocumentsNeoliane()"
                          [disabled]="!product.data?.documents || product.data.documents === 0">
                        </button>
                        <button pButton type="button" class="devis-icon-btn"
                          pTooltip="Souscrire - Accéder au formulaire Neoliane" icon="pi pi-external-link"
                          (click)="souscrireNeoliane(product)" [disabled]="neolianeLoading || !product.data?.eligible"
                          style="background-color: #2c5282; color: white;">
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <!-- Produit AFI-ESCA -->
                <ng-container *ngIf="product.type === 'afiesca'">
                  <div class="result-box afiesca-product" [class.best-price]="i === 0">
                    <div class="product-left">
                      <div class="logo-section">
                        <img src="assets/images/logos/afiesca-logo.png" alt="AFI-ESCA Logo" class="logo-img" />
                      </div>
                      <div class="product-badges">
                        <div class="product-badge product-badge-com">
                          COM / {{ getProductCommissionValue(product) }}
                        </div>
                        <div class="product-badge product-badge-ipt">
                          IPT / {{ getProductCompensationMode(product) }}
                        </div>
                      </div>
                      <h4 class="product-title-main">{{ product.productName }}</h4>
                      <div class="product-subtitle">{{ product.contributionType }}</div>
                    </div>

                    <div class="product-right">
                      <div class="product-price">
                        <div class="price-main">{{ product.monthlyPrice | number:'1.2-2' }}€</div>
                        <div class="price-label">mois <sup>(1)</sup></div>
                        <div class="price-secondary">{{ product.firstYearPrice | number:'1.2-2' }}€ <sup>(2)</sup></div>
                        <div class="price-secondary">{{ product.eightYearsPrice | number:'1.2-2' }}€ <sup>(3)</sup>
                        </div>
                        <div class="price-secondary">{{ product.data?.taea | number:'1.2-2' }}% <sup>(4)</sup></div>
                      </div>

                      <div class="product-details">
                        <div class="detail-item">
                          <span class="detail-label">Couverture de la garantie décès pendant toute la durée du
                            prêt:</span>
                          <span class="detail-value age">jusqu'à 91 ans</span>
                        </div>
                        <div class="detail-item">
                          <span class="detail-label">Couverture de la garantie PTIA pendant toute la durée du
                            prêt:</span>
                          <span class="detail-value age">jusqu'à 71 ans</span>
                        </div>
                        <div class="detail-item">
                          <span class="detail-label">Couverture de la garantie incapacité pendant toute la durée du
                            prêt:</span>
                          <span class="detail-value age">jusqu'à 65 ans</span>
                        </div>
                        <div class="detail-item">
                          <span class="detail-label">Couverture de la garantie invalidité pendant toute la durée du
                            prêt:</span>
                          <span class="detail-value age">jusqu'à 65 ans</span>
                        </div>
                      </div>

                      <div class="product-actions">
                        <button pButton type="button" class="devis-icon-btn" pTooltip="Voir les détails"
                          icon="pi pi-search">
                        </button>
                        <button pButton type="button" class="devis-icon-btn"
                          [pTooltip]="isProductSelected(product) ? 'Retirer de la sélection' : 'Ajouter à la sélection'"
                          [icon]="isProductSelected(product) ? 'pi pi-check' : 'pi pi-plus'"
                          (click)="toggleProductSelection(product)">
                        </button>
                        <button pButton type="button" class="devis-icon-btn"
                          pTooltip="Télécharger le devis AFI-ESCA (PDF)" icon="pi pi-file-pdf"
                          (click)="genererDevisAfiesca(product)" [disabled]="afiescaLoading">
                        </button>
                        <button pButton type="button" class="devis-icon-btn" pTooltip="Créer projet AFI-ESCA (Extranet)"
                          icon="pi pi-external-link" (click)="creerProjetAfiesca()" [disabled]="loading">
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <!-- Produit LifeSquare -->
                <ng-container *ngIf="product.type === 'lifesquare'">
                  <div class="result-box lifesquare-product" [class.best-price]="i === 0">
                    <div class="product-left">
                      <div class="logo-section">
                        <img src="assets/images/logos/logo-lifesquare.png" alt="LifeSquare Logo" class="logo-img"
                          onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';" />
                        <div class="logo-fallback"
                          style="display:none; width:80px; height:40px; background:#2c5282; color:white; font-weight:bold; align-items:center; justify-content:center; border-radius:4px;">
                          LIFE
                        </div>
                      </div>
                      <div class="product-badges">
                        <div class="product-badge product-badge-com">
                          COM / {{ getProductCommissionValue(product) }}
                        </div>
                        <div class="product-badge product-badge-ipt">
                          IPT / {{ getProductCompensationMode(product) }}
                        </div>
                      </div>
                      <h4 class="product-title-main">{{ product.productName }}</h4>
                      <div class="product-subtitle">{{ product.assureur || 'LifeSquare' }} - {{ product.contributionType
                        }}</div>
                      <div class="product-code" *ngIf="product.productCode">{{ product.productCode }}</div>
                    </div>

                    <div class="product-right">
                      <div class="product-price">
                        <div class="price-main">{{ product.monthlyPrice | number:'1.2-2' }}€</div>
                        <div class="price-label">mois <sup>(1)</sup></div>
                        <div class="price-secondary">{{ product.firstYearPrice | number:'1.2-2' }}€ <sup>(2)</sup></div>
                        <div class="price-secondary">{{ product.eightYearsPrice | number:'1.2-2' }}€ <sup>(3)</sup>
                        </div>
                        <div class="price-secondary">{{ product.data?.taea | number:'1.2-2' }}% <sup>(4)</sup></div>
                      </div>

                      <div class="product-details">
                        <div class="detail-item" *ngIf="product.data?.offer?.name">
                          <span class="detail-label">Offre:</span>
                          <span class="detail-value">{{ product.data?.offer?.name }}</span>
                        </div>
                        <div class="detail-item" *ngIf="product.data?.quotations_count !== undefined">
                          <span class="detail-label">Nombre de devis:</span>
                          <span class="detail-value">{{ product.data?.quotations_count }}</span>
                        </div>
                        <div class="detail-item" *ngIf="product.data?.subscription_accessible !== undefined">
                          <span class="detail-label">Souscription:</span>
                          <span class="detail-value">{{ product.data?.subscription_accessible ? 'Disponible' : 'Non
                            disponible' }}</span>
                        </div>
                      </div>

                      <div class="product-actions">
                        <button pButton type="button" class="devis-icon-btn" pTooltip="Voir les détails"
                          icon="pi pi-search">
                        </button>
                        <button pButton type="button" class="devis-icon-btn" pTooltip="Télécharger le devis (PDF)"
                          icon="pi pi-file-pdf" (click)="telechargerDevisLifesquare(product)"
                          [disabled]="lifesquareLoading">
                        </button>
                        <button pButton type="button" class="devis-icon-btn"
                          [pTooltip]="isProductSelected(product) ? 'Retirer de la sélection' : 'Ajouter à la sélection'"
                          [icon]="isProductSelected(product) ? 'pi pi-check' : 'pi pi-plus'"
                          (click)="toggleProductSelection(product)">
                        </button>
                        <button pButton type="button" class="devis-icon-btn"
                          pTooltip="Modifier la commission LifeSquare"
                          icon="pi pi-percentage"
                          (click)="updateLifesquareCommissionForProduct(product)"
                          [disabled]="lifesquareLoading"
                          style="background-color: #8b5cf6; color: white;">
                        </button>
                        <button pButton type="button" class="devis-icon-btn" [pTooltip]="(!product.productCode && !product.data?.offer?.id)
                            ? 'Offre non souscriptible (identifiant offre manquant)'
                            : 'Souscrire - Accéder à la fiche LifeSquare'" icon="pi pi-external-link"
                          (click)="souscrireLifesquare(product)" [disabled]="lifesquareLoading
                            || (!product.productCode && !product.data?.offer?.id)"
                          style="background-color: #2c5282; color: white;">
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <!-- Produit Zenioo -->
                <!-- Produit Zenioo -->
                <ng-container *ngIf="product.type === 'zenioo'">
                  <div class="result-box zenioo-product" [class.best-price]="i === 0 && !product.data?.lemoineExcluded"
                    [style.opacity]="product.data?.lemoineExcluded ? '0.68' : null"
                    [style.filter]="product.data?.lemoineExcluded ? 'grayscale(0.35)' : null">
                    <div class="product-left">
                      <div class="logo-section">
                        <img src="assets/images/logos/zenioo-logo.png" alt="Zenioo Logo" class="logo-img"
                          onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';" />
                        <div class="logo-fallback"
                          style="display:none; width:80px; height:40px; background:#2c5282; color:white; font-weight:bold; align-items:center; justify-content:center; border-radius:4px;">
                          {{ product.assureur || 'ZENIOO' }}
                        </div>
                      </div>
                      <div class="product-badges">
                        <div class="product-badge product-badge-com">
                          COM / {{ getProductCommissionValue(product) }}
                        </div>
                        <div class="product-badge product-badge-ipt">
                          IPT / {{ getProductCompensationMode(product) }}
                        </div>
                        <div *ngIf="product.data?.lemoineExcluded" class="product-badge"
                          style="background: #dc2626; color: #ffffff;">
                          Non éligible – Lemoine
                        </div>
                      </div>
                      <h4 class="product-title-main">{{ product.productName }}</h4>
                      <div class="product-subtitle">{{ product.assureur }} - {{ product.contributionType }}</div>
                      <div class="product-code">{{ product.productCode }}</div>
                    </div>

                    <div class="product-right">
                      <div class="product-price">
                        <div class="price-main">{{ product.monthlyPrice | number:'1.2-2' }}€</div>
                        <div class="price-label">mois <sup>(1)</sup></div>
                        <div class="price-secondary">{{ product.firstYearPrice | number:'1.2-2' }}€ <sup>(2)</sup></div>
                        <div class="price-secondary">{{ product.eightYearsPrice | number:'1.2-2' }}€ <sup>(3)</sup>
                        </div>
                        <div class="price-secondary">{{ product.data?.taea | number:'1.2-2' }}% <sup>(4)</sup></div>
                      </div>

                      <div class="product-details">
                        <div class="detail-item" *ngIf="product.data?.libelle_produit">
                          <span class="detail-label">Produit:</span>
                          <span class="detail-value">{{ product.data?.libelle_produit }}</span>
                        </div>
                        <div class="detail-item" *ngIf="product.data?.libelle_formule">
                          <span class="detail-label">Formule:</span>
                          <span class="detail-value">{{ product.data?.libelle_formule }}</span>
                        </div>
                        <div class="detail-item" *ngIf="product.data?.frais_courtage">
                          <span class="detail-label">Frais courtage inclus:</span>
                          <span class="detail-value">{{ product.data?.frais_courtage | number:'1.2-2' }}€</span>
                        </div>
                      </div>

                      <div class="product-actions">
                        <button pButton type="button" class="devis-icon-btn" pTooltip="Voir les détails"
                          icon="pi pi-search">
                        </button>
                        <button pButton type="button" class="devis-icon-btn"
                          [pTooltip]="product.data?.lemoineExcluded ? 'Non éligible – Lemoine' : (isProductSelected(product) ? 'Retirer de la sélection' : 'Ajouter à la sélection')"
                          [icon]="isProductSelected(product) ? 'pi pi-check' : 'pi pi-plus'"
                          (click)="toggleProductSelection(product)" [disabled]="product.data?.lemoineExcluded">
                        </button>
                        <button pButton type="button" class="devis-icon-btn"
                          pTooltip="Télécharger le devis Zenioo (PDF)" icon="pi pi-file-pdf"
                          (click)="telechargerDevisZenioo(product)"
                          [disabled]="zeniooLoading || product.data?.lemoineExcluded">
                        </button>
                        <button pButton type="button" class="devis-icon-btn" pTooltip="Envoyer le devis par email"
                          icon="pi pi-envelope" (click)="envoyerDevisZeniooParEmail(product)"
                          [disabled]="zeniooLoading || product.data?.lemoineExcluded">
                        </button>
                        <button pButton type="button" class="devis-icon-btn"
                          pTooltip="Souscrire - Accéder au formulaire Zenioo" icon="pi pi-external-link"
                          (click)="souscrireZenioo(product)" [disabled]="zeniooLoading || product.data?.lemoineExcluded"
                          style="background-color: #2c5282; color: white;">
                        </button>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </ng-container>

            </div>
            <div id="top10-capture" [ngStyle]="{ position: 'absolute', left: '-9999px', top: '0', width: '1200px' }">
              <div class="products-grid">
                <ng-container *ngFor="let product of getFilteredProducts().slice(0, 10); let i = index">
                  <!-- Produit April -->
                  <ng-container *ngIf="product.type === 'april'">
                    <div class="result-box april-product" [class.best-price]="i === 0">
                      <div class="product-left">
                        <div class="logo-section">
                          <img src="assets/images/logos/april-logo.png" alt="April Logo" class="logo-img" />
                        </div>
                        <div class="product-badges">
                          <div class="product-badge product-badge-com">
                            COM / {{ getProductCommissionValue(product) }}
                          </div>
                          <div class="product-badge product-badge-ipt">
                            IPT / {{ getProductCompensationMode(product) }}
                          </div>
                          <div *ngIf="product.hasWarnings" class="product-badge product-badge-warning"
                            pTooltip="Ce produit a des garanties partielles. Voir les détails." tooltipPosition="top">
                            <i class="pi pi-exclamation-triangle"></i> Garanties partielles
                          </div>
                        </div>
                        <h4 class="product-title-main">{{ product.productName }}</h4>
                        <div class="product-subtitle">{{ product.contributionType || 'Cotisation Variable' }}</div>
                      </div>
                      <div class="product-right">
                        <div class="product-price">
                          <ng-container *ngIf="hasAprilProductPricing(product); else noAprilCapturePricing">
                            <div class="price-main">{{ product.monthlyPrice | number:'1.2-2' }}€</div>
                            <div class="price-label">
                              {{ product.isAprilMixedOffer ? 'mois couple' : 'mois' }} <sup>(1)</sup>
                            </div>
                            <div class="price-secondary">{{ product.firstYearPrice | number:'1.2-2' }}€ <sup>(2)</sup>
                            </div>
                            <div class="price-secondary">{{ product.eightYearsPrice | number:'1.2-2' }}€ <sup>(3)</sup>
                            </div>
                            <div class="price-secondary">
                              <ng-container *ngIf="getAprilDisplayedTaea(product) !== null; else noAprilCaptureTaea">
                                {{ getAprilDisplayedTaea(product) | number:'1.2-2' }}% <sup>(4)</sup>
                              </ng-container>
                              <ng-template #noAprilCaptureTaea>- <sup>(4)</sup></ng-template>
                            </div>
                          </ng-container>
                          <ng-template #noAprilCapturePricing>
                            <div class="price-main april-unavailable-price">Non tarifable</div>
                            <div class="price-label">Retour métier APRIL</div>
                            <div class="price-secondary">- <sup>(2)</sup></div>
                            <div class="price-secondary">- <sup>(3)</sup></div>
                            <div class="price-secondary">- <sup>(4)</sup></div>
                          </ng-template>

                        </div>
                        <div class="product-details" [class.april-mixed-details]="product.isAprilMixedOffer">
                          <ng-container *ngIf="product.isAprilMixedOffer; else standardAprilCaptureDetails">
                            <div class="detail-item april-mixed-detail-item">
                              <span class="detail-label">Emprunteur :</span>
                              <span class="detail-value april-mixed-detail-value">
                                <span class="april-mixed-product-name">{{ product.aprilMainProductName }}</span>
                                <span class="april-mixed-product-price">
                                  {{ getAprilMixedOfferTotal(product, 'main') | number:'1.2-2' }} €
                                </span>
                                <span class="april-mixed-monthly">
                                  ({{ getAprilMixedOfferMonthly(product, 'main') | number:'1.2-2' }} € / mois)
                                </span>
                              </span>
                            </div>
                            <div class="detail-item april-mixed-detail-item">
                              <span class="detail-label">Co-emprunteur :</span>
                              <span class="detail-value april-mixed-detail-value">
                                <span class="april-mixed-product-name">{{ product.aprilCoProductName }}</span>
                                <span class="april-mixed-product-price">
                                  {{ getAprilMixedOfferTotal(product, 'co') | number:'1.2-2' }} €
                                </span>
                                <span class="april-mixed-monthly">
                                  ({{ getAprilMixedOfferMonthly(product, 'co') | number:'1.2-2' }} € / mois)
                                </span>
                              </span>
                            </div>
                            <div class="detail-item april-mixed-detail-item">
                              <span class="detail-label">Cotisation :</span>
                              <span class="detail-value april-mixed-detail-value">{{ product.contributionType }}</span>
                            </div>
                            <div class="detail-item april-mixed-detail-item">
                              <span class="detail-label">IPT :</span>
                              <span class="detail-value april-mixed-detail-value">
                                {{ getAprilMixedOfferCompensationSummary(product) }}
                              </span>
                            </div>
                          </ng-container>
                          <ng-template #standardAprilCaptureDetails>
                            <div class="detail-item">
                              <span class="detail-label">Couverture de la garantie décès pendant toute la durée du
                                prêt:</span>
                              <span class="detail-value age">jusqu'à 91 ans</span>
                            </div>
                            <div class="detail-item">
                              <span class="detail-label">Couverture de la garantie PTIA pendant toute la durée du
                                prêt:</span>
                              <span class="detail-value age">jusqu'à 71 ans</span>
                            </div>
                            <div class="detail-item">
                              <span class="detail-label">Couverture de la garantie incapacité pendant toute la durée du
                                prêt:</span>
                              <span class="detail-value age">jusqu'à 65 ans</span>
                            </div>
                            <div class="detail-item">
                              <span class="detail-label">Couverture de la garantie invalidité pendant toute la durée du
                                prêt:</span>
                              <span class="detail-value age">jusqu'à 65 ans</span>
                            </div>
                          </ng-template>
                        </div>
                        <div class="product-actions">
                          <button pButton type="button" class="devis-icon-btn" pTooltip="Voir les détails"
                            icon="pi pi-search"></button>
                          <button *ngIf="hasAprilProductBusinessMessages(product)" pButton type="button"
                            class="devis-icon-btn april-alert-btn" pTooltip="Voir les alertes APRIL"
                            icon="pi pi-exclamation-triangle" (click)="openAprilBusinessMessagesDialog(product)">
                          </button>
                          <button pButton type="button" class="devis-icon-btn" pTooltip="Ajouter à la sélection"
                            icon="pi pi-bookmark" [disabled]="!isAprilProductActionable(product)"></button>
                          <button pButton type="button" class="devis-icon-btn" pTooltip="Télécharger le PDF April"
                            icon="pi pi-file-pdf" (click)="genererPdfApril(product)"
                            [disabled]="loading || !isAprilProductActionable(product)"></button>
                          <button pButton type="button" class="devis-icon-btn" pTooltip="Envoyer par mail"
                            (click)="genererDevisApril(product)" icon="pi pi-envelope"
                            [disabled]="!isAprilProductActionable(product)"></button>
                          <button pButton type="button" class="devis-icon-btn" pTooltip="Créer projet April (Extranet)"
                            icon="pi pi-external-link" (click)="creerProjetApril(product)"
                            [disabled]="loading || !isAprilProductActionable(product)"></button>
                        </div>
                        <!-- Affichage des PDF April générés -->

                      </div>

                    </div>
                  </ng-container>

                  <!-- Produit Cardif -->
                  <ng-container *ngIf="product.type === 'cardif'">
                    <div class="result-box cardif-product" [class.best-price]="i === 0">
                      <div class="product-left">
                        <div class="logo-section">
                          <img src="assets/images/logos/cardif-logo.png" alt="Cardif Logo" class="logo-img" />
                        </div>
                        <div class="product-badges">
                          <div class="product-badge product-badge-com">
                            COM / {{ getProductCommissionValue(product) }}
                          </div>
                          <div class="product-badge product-badge-ipt">
                            IPT / {{ getProductCompensationMode(product) }}
                          </div>
                        </div>
                        <h4 class="product-title-main">{{ product.productName }}</h4>
                        <div class="product-subtitle">
                          {{ product.contributionType }}
                        </div>
                      </div>
                      <div class="product-right">
                        <div class="product-price">
                          <div class="price-main">
                            {{ product.monthlyPrice | number:'1.2-2' }} €
                          </div>
                          <div class="price-label">Cotisation mensuelle</div>
                          <div class="price-secondary" *ngIf="product.firstYearPrice">
                            1ère année : {{ product.firstYearPrice | number:'1.2-2' }} €
                          </div>
                          <div class="price-secondary" *ngIf="product.eightYearsPrice">
                            8 ans : {{ product.eightYearsPrice | number:'1.2-2' }} €
                          </div>
                          <div class="price-secondary" *ngIf="product.data?.tauxMoyen">
                            {{ (product.data.tauxMoyen) | number:'1.2-2' }} %
                          </div>
                        </div>
                        <div class="product-details">
                          <div class="detail-item">
                            <span class="detail-label">Couverture de la garantie décès pendant toute la durée du
                              prêt:</span>
                            <span class="detail-value age">jusqu'à 90 ans </span>
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">Couverture de la garantie PTIA pendant toute la durée du
                              prêt:</span>
                            <span class="detail-value age">jusqu'à 65 ans</span>
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">Couverture de la garantie Incapacité pendant toute la durée du
                              prêt:</span>
                            <span class="detail-value age">jusqu'à 65 ans</span>
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">Couverture de la garantie Invalidité pendant toute la durée du
                              prêt:</span>
                            <span class="detail-value age">jusqu'à 65 ans</span>
                          </div>
                        </div>
                        <div class="product-actions">
                          <button pButton type="button" class="devis-icon-btn" pTooltip="Voir les détails"
                            icon="pi pi-search"></button>
                          <button pButton type="button" class="devis-icon-btn" pTooltip="Ajouter à la sélection"
                            icon="pi pi-bookmark"></button>

                          <button pButton type="button" class="devis-icon-btn"
                            pTooltip="Générer le devis Cardif (PDF + Email)"
                            (click)="genererDevisCardif(product.data.codeProduit)" icon="pi pi-file-pdf"
                            [disabled]="loading">
                          </button>
                          <button pButton type="button" icon="pi pi-envelope">
                          </button>
                          <button pButton type="button" class="devis-icon-btn"
                            pTooltip="Souscrire - Accéder au formulaire Cardif Sésame" icon="pi pi-external-link"
                            (click)="souscrireCardif(product)" [disabled]="cardifLoading"
                            style="background-color: #2c5282; color: white;">
                          </button>
                        </div>
                      </div>
                    </div>
                  </ng-container>


                  <!-- Produit Utwin -->
                  <ng-container *ngIf="product.type === 'utwin'">
                    <div class="result-box utwin-product" [class.best-price]="i === 0">
                      <div class="product-left">
                        <div class="logo-section">
                          <img src="assets/images/logos/utwin-logo.png" alt="Utwin Logo" class="logo-img" />
                        </div>
                        <div class="product-badges">
                          <div class="product-badge product-badge-com">
                            COM / {{ getProductCommissionValue(product) }}
                          </div>
                          <div class="product-badge product-badge-ipt">
                            IPT / {{ getProductCompensationMode(product) }}
                          </div>
                        </div>
                        <h4 class="product-title-main">{{ product.productName }}</h4>
                        <div class="product-subtitle">{{ product.contributionType || 'Cotisation Variable' }}</div>
                      </div>
                      <div class="product-right">
                        <div class="product-price">
                          <div class="price-main">{{ product.monthlyPrice | number:'1.2-2' }}€</div>
                          <div class="price-label">mois <sup>(1)</sup></div>
                          <div class="price-secondary">{{ product.firstYearPrice | number:'1.2-2' }}€ <sup>(2)</sup>
                          </div>
                          <div class="price-secondary">{{ product.eightYearsPrice | number:'1.2-2' }}€ <sup>(3)</sup>
                          </div>
                          <div class="price-secondary">{{ product.data.taea | number:'1.2-2' }}% <sup>(4)</sup></div>


                        </div>
                        <div class="product-details">
                          <div class="detail-item">
                            <span class="detail-label">Couverture de la garantie décès pendant toute la durée du
                              prêt:</span>
                            <span class="detail-value age">jusqu'à 91 ans</span>
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">Couverture de la garantie PTIA pendant toute la durée du
                              prêt:</span>
                            <span class="detail-value age">jusqu'à 71 ans</span>
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">Couverture de la garantie incapacité pendant toute la durée du
                              prêt:</span>
                            <span class="detail-value age">jusqu'à 65 ans</span>
                          </div>
                          <div class="detail-item">
                            <span class="detail-label">Couverture de la garantie invalidité pendant toute la durée du
                              prêt:</span>
                            <span class="detail-value age">jusqu'à 65 ans</span>
                          </div>

                        </div>
                        <div class="product-actions">
                          <button pButton type="button" class="devis-icon-btn" pTooltip="Voir les détails"
                            icon="pi pi-search"></button>
                          <button pButton type="button" class="devis-icon-btn" pTooltip="Ajouter à la sélection"
                            icon="pi pi-bookmark"></button>
                          <button pButton type="button" icon="pi pi-file-pdf"
                            (click)="downloadUtwinPdf(product.data?.RefSimu)"
                            [disabled]="loading || !product.data?.RefSimu">
                          </button>
                          <button pButton type="button" icon="pi pi-envelope"
                            (click)="genererDevisUtwin(product.data.RefSimu)"
                            [disabled]="!product.data?.RefSimu || loading">
                          </button>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                </ng-container>

              </div>
            </div>

            <div *ngIf="!hasVisibleProducts()" class="no-products">
              <i class="pi pi-info-circle"></i>
              <h4>Aucun produit trouvé</h4>
              <p>Aucun produit d'assurance ne correspond à vos critères de filtrage.</p>
              <p>Essayez d'ajuster vos filtres pour voir plus de résultats.</p>
            </div>
          </div>
        </div>
        <!-- Affichage du JSON complet de tous les produits filtrés -->

      </div>

      <!-- Debug: Payload et Réponse -->
      <div *ngIf="activeStep === 3 && showStep4Debug" class="json-debug-section" style="margin-top:2rem;">
        <p-dialog header="Alertes APRIL" [(visible)]="showAprilBusinessMessagesDialog" [modal]="true" [closable]="true"
          [style]="{ width: '720px', maxWidth: '95vw' }" (onHide)="closeAprilBusinessMessagesDialog()">
          <div *ngIf="aprilBusinessMessagesDialogProductName" class="april-dialog-product-title">
            {{ aprilBusinessMessagesDialogProductName }}
          </div>

          <div *ngIf="aprilBusinessMessagesDialogMessages.length > 0; else noAprilDialogMessages"
            class="april-business-messages april-business-messages-dialog">
            <div *ngFor="let message of aprilBusinessMessagesDialogMessages" class="april-business-message-card"
              [ngClass]="'april-business-message-' + getAprilBusinessMessageTone(message)">
              <div class="april-business-message-meta">
                <span class="april-business-message-badge">
                  {{ getAprilBusinessMessageStatusLabel(message) }}
                </span>
                <span>{{ getAprilBusinessMessageInsuredLabel(message) }}</span>
                <span *ngIf="message.messageType">{{ message.messageType }}</span>
              </div>
              <div class="april-business-message-title">
                {{ message.messageTitle }}
              </div>
              <div class="april-business-message-reference" *ngIf="message.messageReference">
                Référence : {{ message.messageReference }}
              </div>
            </div>
          </div>

          <ng-template #noAprilDialogMessages>
            <p-message severity="info" text="Aucun message métier APRIL pour ce produit."></p-message>
          </ng-template>

          <ng-template pTemplate="footer">
            <div class="form-actions dialog-form-actions" style="justify-content: flex-end;">
              <p-button type="button" label="Fermer" styleClass="p-button-text"
                (onClick)="closeAprilBusinessMessagesDialog()">
              </p-button>
            </div>
          </ng-template>
        </p-dialog>

        <p-tabView>
          <p-tabPanel header="Formulaire envoyé">
            <pre
              style="max-height:400px;overflow:auto;background:#f7f7f7;padding:1em;border-radius:6px;font-size:12px;">{{ sentData | json }}</pre>
          </p-tabPanel>
          <p-tabPanel header="Payload Utwin">
            <pre
              style="max-height:400px;overflow:auto;background:#e8f5e9;padding:1em;border-radius:6px;font-size:12px;">{{ result?.payloads?.utwin | json }}</pre>
          </p-tabPanel>
          <p-tabPanel header="Payload April">
            <pre
              style="max-height:400px;overflow:auto;background:#e3f2fd;padding:1em;border-radius:6px;font-size:12px;">{{ result?.payloads?.april | json }}</pre>
          </p-tabPanel>
          <p-tabPanel header="Payload Cardif">
            <pre
              style="max-height:400px;overflow:auto;background:#fff3e0;padding:1em;border-radius:6px;font-size:12px;">{{ result?.payloads?.cardif | json }}</pre>
          </p-tabPanel>
          <p-tabPanel header="Payload Neoliane">
            <pre
              style="max-height:400px;overflow:auto;background:#fce4ec;padding:1em;border-radius:6px;font-size:12px;">{{ result?.payloads?.neoliane | json }}</pre>
          </p-tabPanel>
          <p-tabPanel header="Payload Afiesca">
            <pre
              style="max-height:400px;overflow:auto;background:#f3e5f5;padding:1em;border-radius:6px;font-size:12px;">{{ result?.payloads?.afiesca | json }}</pre>
          </p-tabPanel>
          <p-tabPanel header="Payload Zenioo">
            <pre
              style="max-height:400px;overflow:auto;background:#e0f7fa;padding:1em;border-radius:6px;font-size:12px;">{{ result?.payloads?.zenioo | json }}</pre>
          </p-tabPanel>
          <p-tabPanel header="Payload LifeSquare">
            <pre
              style="max-height:400px;overflow:auto;background:#e8f5ff;padding:1em;border-radius:6px;font-size:12px;">{{ result?.payloads?.lifesquare | json }}</pre>
          </p-tabPanel>
          <p-tabPanel header="Réponse complète">
            <pre
              style="max-height:400px;overflow:auto;background:#f7f7f7;padding:1em;border-radius:6px;font-size:12px;">{{ result | json }}</pre>
          </p-tabPanel>
        </p-tabView>
      </div>

      <div *ngIf="isPublicDevisRoute && publicSubmissionSuccess" class="public-submit-success"
        style="margin-top: 1.5rem; padding: 1rem; border-radius: 8px; border: 1px solid #c8e6c9; background: #f1f8e9; color: #1b5e20;">
        <div style="font-weight: 700; margin-bottom: 0.35rem;">
          Demande envoyée avec succès
        </div>
        <div *ngIf="publicSubmissionProjectId">
          Référence projet : {{ publicSubmissionProjectId }}
        </div>
      </div>

      <!-- Navigation -->
      <div class="form-actions form-navigation-actions">
        <p-button type="button" label="Précédent" icon="pi pi-chevron-left" [disabled]="activeStep === 0"
          (onClick)="previousStep()" styleClass="p-button-text"></p-button>
        <p-button *ngIf="!isPublicDevisRoute && activeStep === 0 && isLeadTreated"
          type="button"
          [label]="sendingStepOneSavingsEmail ? 'Envoi...' : 'mail economisez (5 min)'"
          icon="pi pi-envelope"
          [disabled]="sendingStepOneSavingsEmail || loading"
          (onClick)="sendStepOneSavingsEmail()"></p-button>
        <p-button *ngIf="!isPublicDevisRoute && activeStep === 0"
          type="button"
          [label]="sendingStepOneFollowUpEmail ? 'Envoi...' : 'mail demande d\'information'"
          icon="pi pi-envelope"
          [disabled]="sendingStepOneFollowUpEmail || loading"
          (onClick)="sendStepOneFollowUpEmail()"></p-button>
        <p-button *ngIf="!isPublicDevisRoute && activeStep === 0 && isLeadTreated"
          type="button"
          [label]="(sendingSmsRappel || sendingDevisResend) ? 'Envoi...' : 'Renvoi DEVIS+SMS'"
          icon="pi pi-mobile"
          [disabled]="sendingSmsRappel || sendingDevisResend || loading"
          (onClick)="sendDevisResendAndSmsRappel()"></p-button>
        <div class="action-buttons">
          <p-button *ngIf="isPublicDevisRoute ? activeStep < 1 : activeStep < 2" type="button" label="Suivant"
            icon="pi pi-chevron-right" iconPos="right" (onClick)="nextStep()"></p-button>
          <p-button *ngIf="!isPublicDevisRoute && activeStep === 2 && !loading" type="submit" label="Comparer"
            icon="pi pi-search"></p-button>
          <p-button *ngIf="isPublicDevisRoute && activeStep === 1 && !loading" type="submit" label="Recevoir devis"
            icon="pi pi-send"></p-button>
          <p-button *ngIf="(isPublicDevisRoute ? activeStep === 1 : activeStep === 2) && loading && canCancel"
            type="button" label="Annuler" icon="pi pi-times" (onClick)="cancelComparison()"
            styleClass="p-button-danger"></p-button>

          <button *ngIf="!isPublicDevisRoute && activeStep === 3" pButton type="button" icon="pi pi-camera"
            (click)="captureTop10()" [disabled]="loading || getFilteredProducts().length === 0">
          </button>
        </div>
      </div>

      <p-message severity="error" *ngIf="error" [text]="error"></p-message>
    </form>
  </div>
  <!-- Overlay de chargement avec spinner centré et bouton annuler (en dehors du conteneur principal) -->
  <div *ngIf="loading && canCancel" class="loading-overlay">
    <div class="loading-content">
      <p-progressSpinner></p-progressSpinner>
      <div class="loading-text">
        <h3>{{ isPublicDevisRoute ? 'Envoi en cours...' : 'Comparaison en cours...' }}</h3>
        <p>{{ isPublicDevisRoute ? 'Nous enregistrons votre demande' : 'Nous analysons les meilleures offres pour vous'
          }}</p>
      </div>
      <p-button type="button" label="Annuler" icon="pi pi-times" (onClick)="cancelComparison()"
        styleClass="p-button-danger p-button-lg">
      </p-button>
    </div>
  </div>

  <p-dialog header="Analyse d'Amortissement" [(visible)]="showAmortissementDialog" [modal]="true"
    [style]="{ width: '900px', maxWidth: '95vw' }" styleClass="amortissement-dialog-styled">
    <div class="amortissement-dialog-content">

      <!-- Section Date d'effet -->
      <div class="amortissement-section">
        <div class="amortissement-section-header">
          <i class="pi pi-calendar"></i>
          <span>Date d'effet</span>
        </div>
        <input pInputText id="amortissementDateEffet" type="date" [(ngModel)]="amortissementEffectiveDate"
          name="amortissementDateEffet" class="amortissement-date-input" />
      </div>

      <!-- Mode Toggle -->
      <div class="amortissement-mode-toggle">
        <div class="amortissement-mode-card" [class.active]="amortissementMode === 'pdf'"
          (click)="selectAmortissementMode('pdf')">
          <i class="pi pi-file-pdf"></i>
          <div class="mode-card-text">
            <strong>Tableau bancaire PDF</strong>
            <span>Importer le relevé bancaire</span>
          </div>
        </div>
        <div class="amortissement-mode-card" [class.active]="amortissementMode === 'manual'"
          (click)="selectAmortissementMode('manual')">
          <i class="pi pi-calculator"></i>
          <div class="mode-card-text">
            <strong>Calcul manuel</strong>
            <span>Saisir le montant mensuel</span>
          </div>
        </div>
      </div>

      <!-- Mode PDF -->
      <div *ngIf="amortissementMode === 'pdf'" class="amortissement-section">
        <div class="amortissement-section-header">
          <i class="pi pi-upload"></i>
          <span>Tableau d'amortissement bancaire (PDF)</span>
        </div>
        <div class="amortissement-dropzone" (dragover)="$event.preventDefault()"
          (drop)="onAmortissementBankFileDrop($event)">
          <input type="file" multiple accept="application/pdf" (change)="onAmortissementBankFileSelected($event)"
            #bankFileInput hidden />
          <div class="dropzone-content" (click)="bankFileInput.click()">
            <i class="pi pi-cloud-upload"></i>
            <span *ngIf="amortissementBankFiles.length === 0">Cliquez ou glissez vos PDF ici</span>
            <div *ngIf="amortissementBankFiles.length > 0" class="dropzone-file-info">
              <i class="pi pi-file-pdf"></i>
              <span>{{ amortissementBankFiles.length }} tableau(x) bancaire(s) selectionne(s)</span>
              <button pButton type="button" icon="pi pi-times" class="p-button-rounded p-button-text p-button-sm"
                (click)="amortissementBankFiles = []; amortissementBankFile = null; $event.stopPropagation()"></button>
            </div>
          </div>
        </div>
        <div class="selected-files-chips" *ngIf="amortissementBankFiles.length > 0">
          <div class="file-chip" *ngFor="let file of amortissementBankFiles; let i = index">
            <i class="pi pi-file-pdf"></i>
            <span>{{ file.name }}</span>
            <button pButton type="button" icon="pi pi-times" class="p-button-rounded p-button-text p-button-sm"
              (click)="removeAmortissementBankFile(i)"></button>
          </div>
        </div>
      </div>

      <!-- Mode Manuel -->
      <div *ngIf="amortissementMode === 'manual'" class="amortissement-section">
        <div class="amortissement-section-header">
          <i class="pi pi-calculator"></i>
          <span>Calcul manuel de l'assurance restante</span>
        </div>
        <div class="amortissement-manual-loans-extra">
          <div class="amortissement-manual-loan" *ngFor="let loan of amortissementManualLoans; let i = index">
            <div class="manual-loan-header" *ngIf="amortissementManualLoans.length > 1">
              <strong>{{ loan.label || ('Pret ' + (i + 1)) }}</strong>
            </div>
            <div class="amortissement-manual-grid">
              <div class="manual-field">
                <label class="manual-label">Mensualité d'assurance (€)</label>
                <input pInputText type="number" [(ngModel)]="loan.monthly" [ngModelOptions]="{standalone: true}"
                  placeholder="Ex: 45.50" min="0" step="0.01" class="manual-input" />
              </div>
              <div class="manual-field">
                <label class="manual-label">Nombre de mois restants (prérempli depuis Durée restante - Step 2)</label>
                <input pInputText type="number" [(ngModel)]="loan.months" [ngModelOptions]="{standalone: true}"
                  placeholder="Modifiable" min="1" step="1" class="manual-input" />
              </div>
              <div class="manual-result" *ngIf="getManualLoanAmount(loan) > 0">
                <div class="manual-result-label">Assurance restante estimée</div>
                <div class="manual-result-value">
                  {{ getManualLoanAmount(loan) | number:'1.2-2' }} €
                </div>
              </div>
            </div>
          </div>
          <div class="manual-total-result" *ngIf="amortissementManualLoans.length > 1">
            <span>Total assurance restante</span>
            <strong>{{ getAmortissementManualTotal() | number:'1.2-2' }} €</strong>
          </div>
        </div>
      </div>

      <!-- Section devis assurance (commune aux 2 modes) -->
      <div class="amortissement-section">
        <div class="amortissement-section-header">
          <i class="pi pi-file-import"></i>
          <span>Devis d'assurance (PDF, max 4) — optionnel</span>
        </div>
        <div class="amortissement-dropzone" (dragover)="$event.preventDefault()">
          <input type="file" multiple accept="application/pdf" (change)="onAmortissementQuoteFilesSelected($event)"
            #quoteFileInput hidden />
          <div class="dropzone-content" (click)="quoteFileInput.click()">
            <i class="pi pi-cloud-upload"></i>
            <span>Cliquez ou glissez vos devis PDF ici</span>
          </div>
        </div>
        <div class="selected-files-chips" *ngIf="amortissementQuoteFiles.length > 0">
          <div class="file-chip" *ngFor="let file of amortissementQuoteFiles; let i = index">
            <i class="pi pi-file-pdf"></i>
            <span>{{ file.name }}</span>
            <button pButton type="button" icon="pi pi-times" class="p-button-rounded p-button-text p-button-sm"
              (click)="removeAmortissementQuoteFile(i)"></button>
          </div>
        </div>
      </div>

      <!-- Loading -->
      <div *ngIf="amortissementLoading" class="amortissement-loading-bar">
        <div class="loading-spinner"></div>
        <span>Analyse en cours...</span>
      </div>

      <!-- Error -->
      <div *ngIf="amortissementError" class="amortissement-error-banner">
        <i class="pi pi-exclamation-triangle"></i>
        <span>{{ amortissementError }}</span>
      </div>

      <!-- Résultats -->
      <div
        *ngIf="(amortissementResult || amortissementManualResult) && insurerQuoteResults && insurerQuoteResults.length"
        class="amortissement-result">
        <div class="result-header">
          <i class="pi pi-chart-bar"></i>
          <h4>ÉCONOMIE RÉALISÉE</h4>
        </div>
        <table class="amortissement-summary-table">
          <thead>
            <tr>
              <th>PROJET EMPRUNTEUR</th>
              <th>ASSURANCE ACTUELLE</th>
              <th *ngFor="let quote of insurerQuoteResults">
                {{ quote.assureur || 'Assureur' }}
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="getAmortissementCurrentRows().length > 1">
              <tr *ngFor="let row of getAmortissementCurrentRows(); let rowIndex = index">
                <td class="project-cell">{{ row.label }}</td>
                <td class="current-insurance-cell">
                  {{ row.amount | number:'1.2-2' }} €
                </td>
                <ng-container *ngIf="rowIndex === 0">
                  <td *ngFor="let quote of insurerQuoteResults" class="quote-value-cell" [class.saving]="isSaving(quote)"
                    [attr.rowspan]="getAmortissementCurrentRows().length">
                    <span class="quote-amount">{{ quote.montant_total | number:'1.2-2' }} {{ quote.currency === 'EUR' ? '€'
                      : quote.currency }}</span>
                    <span class="quote-saving" *ngIf="isSaving(quote)">
                      - {{ getSavingAmount(quote) | number:'1.2-2' }} €
                    </span>
                  </td>
                </ng-container>
              </tr>
            </ng-container>
            <tr *ngIf="getAmortissementCurrentRows().length <= 1">
              <td class="project-cell">{{ getFirstAmortissementCurrentRow().label }}</td>

              <!-- Assurance actuelle selon le mode -->
              <td class="current-insurance-cell">
                <ng-container *ngIf="amortissementMode === 'pdf' && amortissementResult">
                  {{ amortissementResult.summary?.assurance_restante | number:'1.2-2' }}
                  {{ amortissementResult.meta.currency === 'EUR' ? '€' : amortissementResult.meta.currency }}
                </ng-container>
                <ng-container *ngIf="amortissementMode !== 'pdf'">
                  {{ getFirstAmortissementCurrentRow().amount | number:'1.2-2' }}
                  {{ getFirstAmortissementCurrentRow().currency === 'EUR' ? '€' : getFirstAmortissementCurrentRow().currency }}
                </ng-container>
              </td>

              <!-- Colonnes devis assureurs -->
              <td *ngFor="let quote of insurerQuoteResults" class="quote-value-cell" [class.saving]="isSaving(quote)">
                <span class="quote-amount">{{ quote.montant_total | number:'1.2-2' }} {{ quote.currency === 'EUR' ? '€'
                  : quote.currency }}</span>
                <span class="quote-saving" *ngIf="isSaving(quote)">
                  - {{ getSavingAmount(quote) | number:'1.2-2' }} €
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="amortissement-footer">
        <p-button type="button" label="Annuler" icon="pi pi-times" styleClass="p-button-text p-button-secondary"
          (onClick)="closeAmortissementDialog()">
        </p-button>
        <div class="footer-actions">
          <p-button type="button" label="Analyser" icon="pi pi-search" (onClick)="confirmAmortissement()"
            [disabled]="amortissementLoading" styleClass="p-button-raised">
          </p-button>
          <p-button type="button" label="Envoyer par email et SMS" icon="pi pi-envelope" (onClick)="sendAmortissementEmail()"
            [disabled]="(!amortissementResult && !amortissementManualResult) || amortissementLoading"
            styleClass="p-button-raised p-button-success">
          </p-button>
        </div>
      </div>
    </ng-template>
  </p-dialog>

  <p-dialog [(visible)]="showContactConfirmDialog" [modal]="true" [closable]="false" [draggable]="false"
    [style]="{ width: '480px', maxWidth: '95vw' }" styleClass="contact-lookup-dialog">
    <ng-template pTemplate="header">
      <div class="contact-lookup-header">
        <div class="contact-lookup-header-icon" aria-hidden="true">
          <i class="pi pi-user"></i>
        </div>
        <div class="contact-lookup-header-text">
          <span class="contact-lookup-header-title">Contact existant détecté</span>
          <span class="contact-lookup-header-subtitle">Vérifiez l'identité avant de continuer</span>
        </div>
      </div>
    </ng-template>

    <div class="contact-lookup-content" *ngIf="contactLookupPending as contact">
      <p class="contact-lookup-intro">
        Un contact correspondant a été trouvé dans notre base.<br />
        <strong>S'agit-il bien de cette personne ?</strong>
      </p>

      <div class="contact-lookup-card">
        <div class="contact-lookup-profile">
          <div class="contact-lookup-avatar" aria-hidden="true">{{ contactLookupInitials }}</div>
          <div class="contact-lookup-identity">
            <span class="contact-lookup-civilite" *ngIf="contactLookupCiviliteLabel">{{ contactLookupCiviliteLabel }}</span>
            <span class="contact-lookup-name">{{ contactLookupShortName || contactLookupDisplayName }}</span>
          </div>
        </div>

        <div class="contact-lookup-details">
          <div class="contact-lookup-detail-row" *ngIf="contact.email">
            <span class="contact-lookup-detail-icon"><i class="pi pi-envelope"></i></span>
            <div class="contact-lookup-detail-body">
              <span class="contact-lookup-detail-label">Email</span>
              <span class="contact-lookup-detail-value">{{ contact.email }}</span>
            </div>
          </div>
          <div class="contact-lookup-detail-row" *ngIf="contact.telephone">
            <span class="contact-lookup-detail-icon"><i class="pi pi-phone"></i></span>
            <div class="contact-lookup-detail-body">
              <span class="contact-lookup-detail-label">Téléphone</span>
              <span class="contact-lookup-detail-value">{{ contact.telephone }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="contact-lookup-hint">
        <i class="pi pi-info-circle" aria-hidden="true"></i>
        <span>En confirmant, les informations de ce contact seront préremplies dans le formulaire.</span>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <div class="contact-lookup-footer">
        <p-button label="Non, ce n'est pas lui" icon="pi pi-times" severity="secondary" [outlined]="true"
          styleClass="contact-lookup-btn-reject" (onClick)="rejectExistingContact()"></p-button>
        <p-button label="Oui, c'est lui" icon="pi pi-check" styleClass="contact-lookup-btn-confirm"
          (onClick)="confirmExistingContact()"></p-button>
      </div>
    </ng-template>
  </p-dialog>
</div>
